$(document).ready(function () {
  let productNavSlider = $(".product-nav-slider");
  let productThumbSlider = $(".product-thumb-slider");

  if (
    productNavSlider.length > 0 &&
    !productNavSlider.hasClass("slick-initialized") &&
    productThumbSlider.length > 0 &&
    !productThumbSlider.hasClass("slick-initialized")
  ) {
    // The two sliders used to be bound with slick's `asNavFor` + `focusOnSelect`.
    // That behaviour auto-scrolls the thumb strip to keep the clicked thumb
    // visible — which feels "jumpy" because the strip reorders under the
    // cursor. The new design keeps the thumb strip in a fixed order and only
    // moves it when the user uses the up/down arrows (or clicks beyond the
    // current viewport).
    //
    // Implementation: initialise both sliders standalone, then manually bind
    // thumb clicks to `slickGoTo` on the main slider. Arrows control the
    // thumb strip's own scroll; clicks on visible thumbs do NOT move the
    // strip, only the main image.
    productNavSlider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      // Dots always enabled at the JS level — visibility is then gated
      // via CSS so they appear only on mobile (where the thumbnail strip
      // is hidden, so the dots become the "more images available"
      // affordance). Slick's `responsive` option doesn't reliably create
      // / destroy dots on resize, so the always-on-then-CSS-hide pattern
      // is more robust than a breakpoint-specific init.
      dots: true,
      fade: false,
      infinite: false,
      speed: 300,
      prevArrow:
        '<button type="button" class="nav-prev-arrow" aria-label="Previous image"><svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 1L1 9L9 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow:
        '<button type="button" class="nav-next-arrow" aria-label="Next image"><svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L9 9L1 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    });

    // Vertical thumbs on the left for desktop/tablet; horizontal strip below
    // the main image on mobile.
    var useVerticalThumbs = window.matchMedia("(min-width: 768px)").matches;

    productThumbSlider.slick({
      // Mobile shows ~4 thumbs across an ~360-400px viewport (each thumb
      // is 81px including its 7px L/R padding → ~95px outer width). The
      // old setting of 8 was unrealistic and pushed slick into a degenerate
      // "all slides visible / nothing to scroll" state on small screens.
      slidesToShow: useVerticalThumbs ? 5 : 4,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      infinite: false,
      speed: 300,
      centerMode: false,
      // Explicit width on each thumb (set in CSS) means we don't need
      // variableWidth — slick computes slide width from slidesToShow / list
      // width, which is more predictable for swipe distance + arrow paging.
      variableWidth: false,
      vertical: useVerticalThumbs,
      verticalSwiping: useVerticalThumbs,
      swipe: true,
      touchMove: true,
      prevArrow:
        '<button type="button" class="prev-arrow" aria-label="Previous slide"><svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 7L7 1L1 7" stroke="#222329" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow:
        '<button type="button" class="next-arrow" aria-label="Next slide"><svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L7 7L13 1" stroke="#222329" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    });

    // Manual click sync — changes the main image, and auto-scrolls the thumb
    // strip by one step when the user clicks the LAST-visible (or FIRST-
    // visible) thumb. That way any click on an interior thumb keeps the row
    // stationary, but clicking the edge advances it to reveal the next set.
    productThumbSlider.on("click", ".main-product__slider-media", function () {
      if ($(this).hasClass("slick-cloned")) return; // defensive (no clones with infinite:false)
      var index = $(this).data("slick-index");
      if (typeof index !== "number") return;

      productNavSlider.slick("slickGoTo", index);

      var $active = productThumbSlider.find(".main-product__slider-media.slick-active");
      var firstVisible = $active.first().data("slick-index");
      var lastVisible = $active.last().data("slick-index");
      var total = productThumbSlider.find(".main-product__slider-media").length;

      if (index === lastVisible && index < total - 1) {
        productThumbSlider.slick("slickNext");
      } else if (index === firstVisible && index > 0) {
        productThumbSlider.slick("slickPrev");
      }
    });

    // Active-thumb highlight. Paints the currently-shown image's thumb with
    // the active state, but never scrolls the strip to reveal it.
    function setActiveThumb(index) {
      productThumbSlider
        .find(".main-product__slider-media")
        .removeClass("is-active-thumb");
      productThumbSlider
        .find('.main-product__slider-media[data-slick-index="' + index + '"]')
        .addClass("is-active-thumb");
    }
    productNavSlider.on("afterChange", function (event, slick, currentSlide) {
      setActiveThumb(currentSlide);
    });
    setActiveThumb(0);

    // Slick measures container width at init time. On mobile the gallery
    // sits inside a `display: flex; flex-direction: column` wrapper whose
    // children's cross-axis (=width) sometimes hasn't fully settled by
    // the time `$(document).ready` fires (especially with web fonts or
    // late-loading CSS in flight). When that happens slick records each
    // slide as 0px wide, the main image collapses (`padding-top: 100%` of
    // 0 = 0 height), and the gallery looks broken until the user clicks
    // next/prev — which forces slick to re-layout.
    //
    // Fix: re-call `setPosition` once layout is guaranteed to be settled.
    // - rAF after init handles the common case (next paint frame).
    // - window.load handles the slow-load case (images / fonts pending).
    // - 250ms safety net handles the rare case where neither has resolved
    //   the measurement yet (some Safari iOS edge cases).
    function refreshSlidersPosition() {
      if (productNavSlider.hasClass("slick-initialized")) {
        productNavSlider.slick("setPosition");
      }
      if (productThumbSlider.hasClass("slick-initialized")) {
        productThumbSlider.slick("setPosition");
      }
    }
    requestAnimationFrame(refreshSlidersPosition);
    $(window).on("load", refreshSlidersPosition);
    setTimeout(refreshSlidersPosition, 250);
  }

  // add click event on bespoke color change
  $('input[name="bespoke-option"]').on("change", function () {
    let bespokeOptionValue = $('input[name="bespoke-option"]:checked').val();
    if (bespokeOptionValue === "yes") {
      $(".main-product__customise-wrapper.hex_color_option_wrapper").show();
      $(".color_selection_options_wrapper").hide();
    } else {
      $(".main-product__customise-wrapper.hex_color_option_wrapper").hide();
      $(".color_selection_options_wrapper").show();
    }
  });

  const logoWizardState = {
    enabled: false,
    currentStepIndex: 0,
    completedItems: [],
    queuedSizes: [],
    isAddingAdditionalItem: false,
    isSubmissionComplete: false,
    currentDesignExcluded: false,
    $customiseSelection: $(),
    $designSteps: $(),
    $sizeStep: $(),
    $sizeRowsContainer: $(),
    quantitySelections: [],
    $quantityStep: $(),
    $quantityList: $(),
    $reviewStep: $(),
    $detailsStep: $(),
    $volumeInfoBar: $(),
    $backButton: $(),
    $nextButton: $(),
    $progressCurrent: $(),
    $progressTotal: $(),
    $progressBarFill: $(),
    $progressDots: $(),
    $summaryList: $(),
    $summaryHelpText: $(),
    $continueDetailsButton: $(),
    $sizeAddButton: $(),
    $queuedSizeList: $(),
  };

  function safeTrim(value) {
    if (value === undefined || value === null) {
      return "";
    }
    return String(value).trim();
  }

  function getCustomDimensionsLabel() {
    const width = safeTrim($('input[name="width"]').val());
    const length = safeTrim($('input[name="length"]').val());
    if (!width || !length) {
      return "";
    }
    return `${width}cm x ${length}cm`;
  }

  function getCustomSizeDisplayText() {
    const dimensionsLabel = getCustomDimensionsLabel();
    return dimensionsLabel
      ? `Custom Size (${dimensionsLabel})`
      : "Need a custom size?";
  }

  function isCustomOptionElement($option) {
    if (!$option || !$option.length) {
      return false;
    }
    const optionText = safeTrim($option.attr("data-text") || $option.text()).toLowerCase();
    return optionText.indexOf("custom") > -1 || optionText.indexOf("bespoke") > -1;
  }

  function isCustomSelectionForSizeSelect($sizeSelect) {
    if (!$sizeSelect || !$sizeSelect.length) {
      return false;
    }
    const $activeOption = $sizeSelect
      .find(".cw-product-bundle__variant-options .cw-product-bundle__variant-option.active-status")
      .first();
    if ($activeOption.length > 0) {
      return isCustomOptionElement($activeOption);
    }
    const selectedText = safeTrim(
      $sizeSelect.find(".cw-product-bundle__variant-selected .cw-product-bundle__variant-text").text()
    ).toLowerCase();
    return selectedText.indexOf("custom") > -1 || selectedText.indexOf("bespoke") > -1;
  }

  function normalizeComparableLabel(value) {
    return safeTrim(value).toLowerCase().replace(/\s+/g, " ");
  }

  function resolveSizeSelectMatchedOption($sizeSelect) {
    if (!$sizeSelect || !$sizeSelect.length) {
      return $();
    }

    const $options = $sizeSelect.find(
      ".cw-product-bundle__variant-options .cw-product-bundle__variant-option"
    );
    if ($options.length === 0) {
      return $();
    }

    const selectedDisplayText = normalizeComparableLabel(
      $sizeSelect.find(".cw-product-bundle__variant-selected .cw-product-bundle__variant-text").text()
    );
    const selectedHiddenValue = normalizeComparableLabel(
      $sizeSelect.find('input[type="hidden"]').val()
    );

    let $matchedOption = $();

    if (selectedHiddenValue) {
      $matchedOption = $options.filter(function () {
        const $option = $(this);
        const optionDataText = normalizeComparableLabel($option.attr("data-text"));
        const optionLabelText = normalizeComparableLabel(
          $option.find(".cw-product-bundle__option-text").first().text() || $option.text()
        );
        const optionDisplayText = normalizeComparableLabel($option.attr("data-display-text"));
        return (
          selectedHiddenValue === optionDataText ||
          selectedHiddenValue === optionLabelText ||
          selectedHiddenValue === optionDisplayText
        );
      }).first();
    }

    if ($matchedOption.length === 0 && selectedDisplayText) {
      $matchedOption = $options.filter(function () {
        const $option = $(this);
        const optionDataText = normalizeComparableLabel($option.attr("data-text"));
        const optionLabelText = normalizeComparableLabel(
          $option.find(".cw-product-bundle__option-text").first().text() || $option.text()
        );
        const optionDisplayText = normalizeComparableLabel($option.attr("data-display-text"));
        return (
          selectedDisplayText === optionDataText ||
          selectedDisplayText === optionLabelText ||
          selectedDisplayText === optionDisplayText
        );
      }).first();
    }

    return $matchedOption;
  }

  function resolveSizeSelectVariantId($sizeSelect) {
    if (!$sizeSelect || !$sizeSelect.length) {
      return "";
    }

    const activeVariantId = safeTrim(
      $sizeSelect
        .find(".cw-product-bundle__variant-options .cw-product-bundle__variant-option.active-status")
        .first()
        .attr("data-variant-id")
    );
    if (activeVariantId) {
      return activeVariantId;
    }

    const persistedVariantId = safeTrim($sizeSelect.attr("data-selected-variant-id"));
    if (persistedVariantId) {
      return persistedVariantId;
    }

    const $matchedOption = resolveSizeSelectMatchedOption($sizeSelect);
    if ($matchedOption.length > 0) {
      return safeTrim($matchedOption.attr("data-variant-id"));
    }

    return "";
  }

  function isCustomSizeSelectedOnSizeSelect($sizeSelect) {
    if (!$sizeSelect || !$sizeSelect.length) {
      return false;
    }

    const persistedCustomFlag = safeTrim($sizeSelect.attr("data-selected-is-custom-size")).toLowerCase();
    if (persistedCustomFlag === "true") {
      return true;
    }
    if (persistedCustomFlag === "false") {
      return false;
    }

    const $matchedOption = resolveSizeSelectMatchedOption($sizeSelect);
    if ($matchedOption.length > 0) {
      return isCustomOptionElement($matchedOption);
    }

    return isCustomSelectionForSizeSelect($sizeSelect);
  }

  function updateCustomSizeLabels() {
    const dimensionsLabel = getCustomDimensionsLabel();
    const customDisplayText = dimensionsLabel
      ? `Custom Size (${dimensionsLabel})`
      : "Custom size";

    $(".main-product__size-option .cw-product-bundle__variant-option--custom-size").each(function () {
      const $option = $(this);
      const $optionText = $option.find(".cw-product-bundle__option-text").first();
      if ($optionText.length > 0) {
        $optionText.text(customDisplayText);
      }
      $option.attr("data-display-text", customDisplayText);
    });

    $(".main-product__size-option .cw-product-bundle__variant-select").each(function () {
      const $sizeSelect = $(this);
      if (!isCustomSelectionForSizeSelect($sizeSelect)) {
        return;
      }
      const $selectedText = $sizeSelect
        .find(".cw-product-bundle__variant-selected .cw-product-bundle__variant-text")
        .first();
      if ($selectedText.length > 0) {
        $selectedText.text(customDisplayText);
      }
    });
  }

  function escapeHtml(value) {
    return safeTrim(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function isMatwellLocationSelected() {
    return $("#location-option-2").is(":checked");
  }

  function updateMatwellDependentUI() {
    const isMatwell = isMatwellLocationSelected();
    const $colorPickerWrap = $(".main-product__color-picker-cta-wrap");
    const $customColourSwatch = $("#background-custom-colour");
    const $sizeNote = $(".logo-mat-wizard__matwell-size-note");
    const $colorSwatches = $('input[name="background-color-swatch"]');
    const $fallbackSwatch = $colorSwatches.not($customColourSwatch).first();

    if ($sizeNote.length) {
      $sizeNote.toggle(isMatwell);
    }

    if ($colorPickerWrap.length) {
      $colorPickerWrap.toggle(!isMatwell);
    }

    if ($customColourSwatch.length) {
      $customColourSwatch.prop("disabled", isMatwell);
      if (isMatwell && $customColourSwatch.is(":checked") && $fallbackSwatch.length) {
        $fallbackSwatch.prop("checked", true).trigger("change");
      }
    }

    $("#backgroundCustomColourTrigger, #backgroundCustomColourInput, #backgroundCustomColourHex").prop(
      "disabled",
      isMatwell
    );
  }

  function parseCurrencyAmount(value) {
    const rawValue = safeTrim(value);
    if (!rawValue) {
      return null;
    }
    const normalized = rawValue.replace(/[^0-9.\-]/g, "");
    if (!normalized) {
      return null;
    }
    const parsedValue = parseFloat(normalized);
    return Number.isFinite(parsedValue) ? parsedValue : null;
  }

  function parsePercentAmount(value) {
    const rawValue = safeTrim(value);
    if (!rawValue) {
      return null;
    }
    const normalized = rawValue
      .replace(/save/gi, "")
      .replace(/[^0-9.\-]/g, "");
    if (!normalized) {
      return null;
    }
    const parsedValue = parseFloat(normalized);
    return Number.isFinite(parsedValue) ? parsedValue : null;
  }

  function parseQuantityValue(value) {
    const rawValue = safeTrim(value);
    if (!rawValue) {
      return null;
    }
    const parsedValue = parseFloat(rawValue.replace(/[^0-9.\-]/g, ""));
    return Number.isFinite(parsedValue) ? parsedValue : null;
  }

  function roundToTwo(value) {
    if (!Number.isFinite(value)) {
      return null;
    }
    return Math.round(value * 100) / 100;
  }

  function formatMoneyAmount(value) {
    if (!Number.isFinite(value)) {
      return "";
    }
    const amountInPence = Math.round(value * 100);
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(amountInPence);
    }
    return `£${value.toFixed(2)}`;
  }

  function getQuantityDiscountTiers() {
    const tierMap = { 2: 0, 3: 0, 4: 0 };
    [2, 3, 4].forEach((tierQty) => {
      const tierRaw = safeTrim(
        $(
          `.main-product__quantity-option .cw-product-bundle__variant-option[data-selected-qty="${tierQty}"]`
        ).attr("data-save-percentage")
      );
      const tierPercent = parsePercentAmount(tierRaw);
      tierMap[tierQty] = tierPercent !== null ? tierPercent : 0;
    });
    return tierMap;
  }

  function getDiscountPercentForQty(quantity, tiers) {
    if (quantity >= 4) {
      return tiers[4] || 0;
    }
    if (quantity === 3) {
      return tiers[3] || 0;
    }
    if (quantity === 2) {
      return tiers[2] || 0;
    }
    return 0;
  }

  const INSTANT_PROOF_API_URL =
    window.logoMatInstantProofEndpoint ||
    "https://process-fm-logomat-designs.azurewebsites.net/api/proofs/create";
  const INSTANT_PROOF_CLIENT_TIMEOUT_MS = parseInt(
    window.logoMatInstantProofClientTimeoutMs || "18000",
    10
  );

  function normalizeInstantProofOutcome(rawResponse, fallbackStatus) {
    const raw = rawResponse || {};
    const normalizedStatus = safeTrim(raw.instantProofStatus || fallbackStatus || "failed").toLowerCase();
    const isSuccess = normalizedStatus === "success";
    const resolvedProofMode =
      safeTrim(raw.proofMode || (isSuccess ? "instant" : "manual")).toLowerCase() ||
      (isSuccess ? "instant" : "manual");

    return {
      instantProofStatus: normalizedStatus,
      proofMode: resolvedProofMode,
      requiresManualReview:
        typeof raw.requiresManualReview === "boolean"
          ? raw.requiresManualReview
          : !isSuccess,
      proofId: safeTrim(raw.proofId),
      proofUrl: safeTrim(raw.proofUrl),
      proofImageUrl: safeTrim(raw.proofImageUrl || raw.previewImageUrl),
      draftOrderId: safeTrim(raw.draftOrderId),
      draftOrderInvoiceUrl: safeTrim(raw.draftOrderInvoiceUrl),
      renderDurationMs:
        raw.renderDurationMs !== undefined && raw.renderDurationMs !== null
          ? parseInt(raw.renderDurationMs, 10)
          : null,
      errorCode: safeTrim(raw.errorCode || (isSuccess ? "" : normalizedStatus)),
      errorMessage: safeTrim(raw.message || raw.errorMessage),
      rawStatus: safeTrim(raw.status).toLowerCase(),
    };
  }

  /* Marketing consent — read from Shopify's Customer Privacy API
     (populated by Consentmo, which writes consent into Shopify's
     consent state). STRICTLY READ-ONLY: this never sets or modifies
     consent, it only reports what the visitor has already chosen.

     Resolution order (per the enquiry-database spec):
       1. Explicit `currentVisitorConsent().marketing` when it is an
          unambiguous "yes" or "no".
       2. If that's blank, fall back to `marketingAllowed()`.
       3. If the API is missing → source "shopify_customer_privacy_unavailable".
       4. If the API throws → source "shopify_customer_privacy_error".
     In cases 3/4 we default `allowed` to false (fail-closed: never
     claim consent we couldn't confirm).

     Returns a normalised object the ProofCreate payload spreads into
     its consent fields; the Function App maps them to Dataverse
     cr174_marketingconsent. */
  function getShopifyMarketingConsent() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp) {
        return {
          allowed: false,
          source: "shopify_customer_privacy_unavailable",
          shopifyMarketing: "",
          shopifyAllowed: false,
          consentId: ""
        };
      }

      // Raw explicit visitor consent for marketing: "yes" | "no" | ""
      var explicit = "";
      try {
        var visitorConsent = cp.currentVisitorConsent && cp.currentVisitorConsent();
        explicit = (visitorConsent && visitorConsent.marketing) || "";
      } catch (e) { explicit = ""; }

      // marketingAllowed() boolean (fallback signal)
      var allowedBool = false;
      try {
        allowedBool = !!(cp.marketingAllowed && cp.marketingAllowed());
      } catch (e) { allowedBool = false; }

      // consentId() — audit context only
      var consentId = "";
      try {
        consentId = (cp.consentId && cp.consentId()) || "";
      } catch (e) { consentId = ""; }

      var allowed;
      var source;
      if (explicit === "yes") {
        allowed = true;
        source = "shopify_current_visitor_consent";
      } else if (explicit === "no") {
        allowed = false;
        source = "shopify_current_visitor_consent";
      } else {
        allowed = allowedBool;
        source = "shopify_marketing_allowed";
      }

      return {
        allowed: allowed,
        source: source,
        shopifyMarketing: explicit,
        shopifyAllowed: allowedBool,
        consentId: consentId
      };
    } catch (e) {
      return {
        allowed: false,
        source: "shopify_customer_privacy_error",
        shopifyMarketing: "",
        shopifyAllowed: false,
        consentId: ""
      };
    }
  }

  function buildInstantProofRequestPayload(customerData, primaryDesign, designItems, designItemsObject) {
    const primaryDesignObject =
      Array.isArray(designItemsObject) && designItemsObject.length > 0
        ? designItemsObject[0]
        : null;
    const quantityValue = normalizeQuantityValue(
      (primaryDesignObject && primaryDesignObject.quantityValue) ||
        parseQuantityValue(primaryDesign.quantity) ||
        parseQuantityValue(customerData["Quantity Value"]) ||
        parseQuantityValue(customerData["Quantity"]) ||
        1
    );
    const variantIdValue = safeTrim(
      (primaryDesignObject && primaryDesignObject.productVariantId) ||
        primaryDesign.productVariantId ||
        customerData["Product Variant Id"] ||
        ""
    );
    /* Resolve product_id with the same priority order as variant_id —
       per-design-item field first, then primary design, then customerData
       (kept as a hatch for any future call-site that pre-populates the
       customer dictionary). */
    const productIdValue = safeTrim(
      (primaryDesignObject && primaryDesignObject.productId) ||
        primaryDesign.productId ||
        customerData["Product Id"] ||
        ""
    );
    const productHandleValue = safeTrim(
      (primaryDesignObject && primaryDesignObject.productHandle) ||
        primaryDesign.productHandle ||
        customerData["Product Handle"] ||
        ""
    );
    /* Read marketing consent fresh from Shopify's Customer Privacy API
       at payload-build time (read-only — see getShopifyMarketingConsent). */
    const marketingConsent = getShopifyMarketingConsent();
    /* Meta CAPI signals — read directly from the helper
       (`assets/lm-meta-lead-fields.js`) at payload-build time so the
       values are fresh from browser state, not stale from an earlier
       customerData snapshot. Returns empty object if helper missing.
       Lands in Dataverse cr174_fbc / cr174_fbp / cr174_useragent /
       cr174_eventsourceurl. client_ip is captured server-side from
       request headers in postdata.php and ProofCreate. */
    let metaCapiFields = {};
    try {
      if (typeof window.fmGetMetaLeadFields === 'function') {
        metaCapiFields = window.fmGetMetaLeadFields() || {};
      }
    } catch (e) { /* helper missing — leads still submit without Meta fields */ }
    return {
      // Canonical payload expected by instant proof API
      logo_url: safeTrim(primaryDesign.imageUrl || customerData["Image URL"]),
      background_color: safeTrim(
        primaryDesign.backgroundColor || customerData["Background Color"] || primaryDesign.color
      ),
      size: safeTrim(primaryDesign.customWidth ? "" : primaryDesign.size),
      custom_width: safeTrim(primaryDesign.customWidth),
      custom_length: safeTrim(primaryDesign.customLength),
      orientation: safeTrim(primaryDesign.orientation || customerData["Orientation"] || "landscape"),
      company_name: safeTrim(customerData["Company Name"] || "Customer"),
      quantity: quantityValue,
      source_type: "shopify_wizard",
      /* product_id sent direct from the page (rendered into a data-*
         attribute on the wizard form root) so the Function App can skip
         the variant→product lookup and use this value as authoritative.
         The lookup mis-classified outdoor/circular variants as the indoor
         parent product when the canonical-normalise table was stale; this
         removes the guess. `product_handle` is included for clearer logs. */
      product_id: productIdValue,
      product_handle: productHandleValue,

      // Location / backing for custom-mat border logic in the Function
      Backing: safeTrim(customerData["Backing"] || primaryDesign.backing || ""),

      // Marketing consent — read-only from Shopify Customer Privacy API
      // (Consentmo-backed). Multiple key spellings so the ProofCreate
      // Function App picks up whichever it maps; all resolve to the
      // same value. Lands in Dataverse cr174_marketingconsent.
      marketing_consent: marketingConsent.allowed,
      marketingConsent: marketingConsent.allowed,
      "Marketing Consent": marketingConsent.allowed ? "true" : "false",
      "Marketing Consent Source": marketingConsent.source,
      "Shopify Marketing Consent": marketingConsent.shopifyMarketing,
      "Shopify Marketing Allowed": marketingConsent.shopifyAllowed ? "true" : "false",
      "Shopify Consent ID": marketingConsent.consentId,

      // Marketing attribution — forwarded so Dataverse can classify PAID_SEARCH vs ORGANIC
      gclid: safeTrim(customerData["gclid"] || ""),
      msclkid: safeTrim(customerData["msclkid"] || ""),
      utm_source: safeTrim(customerData["utm_source"] || ""),
      utm_medium: safeTrim(customerData["utm_medium"] || ""),
      utm_campaign: safeTrim(customerData["utm_campaign"] || ""),

      // Meta CAPI signals — see metaCapiFields declaration above
      fbc: safeTrim(metaCapiFields.fbc || ""),
      fbp: safeTrim(metaCapiFields.fbp || ""),
      user_agent: safeTrim(metaCapiFields.user_agent || ""),
      event_source_url: safeTrim(metaCapiFields.event_source_url || ""),

      // Compatibility/additional context fields for traceability
      Firstname: safeTrim(customerData["Firstname"]),
      Surname: safeTrim(customerData["Surname"]),
      Email: safeTrim(customerData["Email"]),
      Phone: safeTrim(customerData["Phone Normalized"] || customerData["Phone"]),
      "Product Variant Id": variantIdValue,
      "Product Id": productIdValue,
      "Product Handle": productHandleValue,
      "Proof Mode": "instant",
      "Instant Proof Eligible": true,
      "Requires Manual Review": false,
      "Design Item Count": designItems.length,
      "Design Items": JSON.stringify(designItems),
      "Design Items Object": designItemsObject,
      "Quantity Value": quantityValue,
    };
  }

  function getPrimarySizeSelect() {
    if (logoWizardState.$sizeRowsContainer.length > 0) {
      return logoWizardState.$sizeRowsContainer
        .find(".logo-mat-wizard__size-row .cw-product-bundle__variant-select")
        .first();
    }
    return $(".main-product__size-option .cw-product-bundle__variant-select").first();
  }

  function getSelectedSizeValue() {
    const $sizeSelect = getPrimarySizeSelect();
    if ($sizeSelect.length === 0) {
      return "";
    }
    return safeTrim(
      $sizeSelect.find(".cw-product-bundle__variant-selected .cw-product-bundle__variant-text").text()
    );
  }

  function isCustomSizeSelection() {
    return isCustomSelectionForSizeSelect(getPrimarySizeSelect());
  }

  function resolveCurrentVariantId() {
    const variantRaw = $(".data-variant-selector").text();
    if (!variantRaw) {
      return "";
    }

    let variantData = [];
    try {
      variantData = JSON.parse(variantRaw);
    } catch (error) {
      return "";
    }

    const selectedOptions = $(".product-set-variant").find(
      "input[type=radio]:checked"
    );
    const selectedOptionValues = [];

    selectedOptions.map((i, elm) => {
      selectedOptionValues.push($(elm).val());
    });

    const currentVariant = variantData.find((variant) =>
      variant.options.every(
        (value, index) => value === selectedOptionValues[index]
      )
    );

    return currentVariant && currentVariant.id ? currentVariant.id : "";
  }

  function buildCurrentDesignItem() {
    const $primarySizeSelect = getPrimarySizeSelect();
    const backingValue = safeTrim($('input[name="select-backing"]:checked').val());
    const orientationValue = safeTrim(
      $('input[name="select-orientation"]:checked').val()
    );
    const selectedSizeValue = getSelectedSizeValue();
    const customWidth = safeTrim($('input[name="width"]').val());
    const customLength = safeTrim($('input[name="length"]').val());
    const selectedProductPriceValue = safeTrim(
      $primarySizeSelect
        .find(".cw-product-bundle__variant-selected .cw-product-bundle__variant-price")
        .first()
        .text()
    );
    const selectedSizeOptionVariantId = resolveSizeSelectVariantId($primarySizeSelect);
    const selectedProductQuantityValue = safeTrim(
      $(".main-product__quantity-option")
        .find(".cw-product-bundle__variant-selected")
        .attr("currentqty")
    );
    const discountPercentageValue = safeTrim(
      $(".main-product__quantity-option")
        .find(
          ".cw-product-bundle__variant-selected .cw-product-bundle__variant-save-percentage"
        )
        .text()
    );
    const totalPriceValue = safeTrim(
      $(".main-product__quantity-option")
        .find(
          ".cw-product-bundle__variant-selected .cw-product-bundle__variant-price"
        )
        .text()
    );
    const selectedColorValue = safeTrim(
      $(".main-product__color-option").find('input[name="color-swatch"]:checked').val()
    );
    const selectedBgColorValue = safeTrim(
      $(".main-product__color-option")
        .find('input[name="background-color-swatch"]:checked')
        .attr("data-color-name")
    );
    const bespokeOptionValue = safeTrim(
      $('input[name="bespoke-option"]:checked').val()
    );

    const uploadedFileUrlInput = $(".main-product__uploaded-file-url");
    const imagePreviewElement = $(".main-product__upload-preview img");
    let imageUrl = "";

    if (uploadedFileUrlInput.length > 0 && safeTrim(uploadedFileUrlInput.val())) {
      imageUrl = safeTrim(uploadedFileUrlInput.val());
    } else if (imagePreviewElement.length > 0) {
      imageUrl = safeTrim(imagePreviewElement.attr("src"));
    }

    /* Resolution chain for the customer's chosen background colour.
       Order matters — the highest-fidelity source wins:

         1. Bespoke text input (#color-option-input) when the bespoke-yes
            radio is selected. That input takes Pantone refs / RGB / hex /
            colour names typed by the customer when they have a brand-spec
            colour to specify.

         2. Currently-checked swatch's friendly name (data-color-name) for
            preset swatches, OR the swatch's `value` attribute (the actual
            hex) for the custom-colour swatch specifically. The custom
            swatch's data-color-name is hardcoded to "Custom Colour" in
            markup and is updated to the actual hex by the picker commit
            handler in main-product.liquid; we still prefer `value` here
            as a defence-in-depth so even if the data-color-name update
            ever fails, the hex flows through.

         3. Defensive fallback to the FIRST preset swatch's data-color-name
            or value — guarantees the payload never carries an empty
            background_color even when the form state is unexpected
            (hidden swatches, JS errors clobbering attributes, etc.).
            Outdoor/circular templates render no swatches at all, so this
            falls through to "" and the call-site below skips the proof
            endpoint entirely (no colour by design — see the gate earlier
            in this function).
    */
    let backgroundColorValue = "";
    if (bespokeOptionValue === "yes") {
      backgroundColorValue = safeTrim($("#color-option-input").val());
    }
    /* Force-manual "describe your colour" free text (Select Background Colour
       step, when the `force_manual_designs` theme setting is on). Treated
       exactly like a typed HEX/Pantone — it overrides the preset swatch but
       yields to an explicit bespoke entry above. Only present in manual mode. */
    if (!backgroundColorValue) {
      var manualColourValue = safeTrim($("#backgroundManualColour").val());
      if (manualColourValue) {
        backgroundColorValue = manualColourValue;
      }
    }
    if (!backgroundColorValue) {
      var $checkedSwatch = $('input[name="background-color-swatch"]:checked').first();
      if ($checkedSwatch.length > 0) {
        var dataName = safeTrim($checkedSwatch.attr("data-color-name"));
        var swatchValue = safeTrim($checkedSwatch.val());
        /* For the custom-colour swatch, the `value` attribute is the actual
           hex (set by the picker commit). data-color-name is also synced
           there but we belt-and-braces with `value` for the custom case. */
        if ($checkedSwatch.attr("id") === "background-custom-colour") {
          backgroundColorValue = swatchValue || dataName;
        } else {
          backgroundColorValue = dataName || swatchValue;
        }
      }
    }
    if (!backgroundColorValue) {
      var $firstSwatch = $('input[name="background-color-swatch"]').first();
      if ($firstSwatch.length > 0) {
        backgroundColorValue =
          safeTrim($firstSwatch.attr("data-color-name")) ||
          safeTrim($firstSwatch.val()) ||
          "";
      }
    }

    /* Read the product identity from the wizard form's data-* attributes
       (rendered by sections/main-product.liquid). Falls back to empty when
       the section isn't on the page (e.g. non-logo-mat product templates),
       which is fine — the payload builder treats it as optional. */
    var $wizardRoot = $(".main-product__customise-selection").first();
    var productId = safeTrim($wizardRoot.attr("data-product-id") || "");
    var productHandle = safeTrim($wizardRoot.attr("data-product-handle") || "");

    const item = {
      location: backingValue,
      orientation: orientationValue,
      size: selectedSizeValue,
      customWidth: isCustomSizeSelectedOnSizeSelect($primarySizeSelect) ? customWidth : "",
      customLength: isCustomSizeSelectedOnSizeSelect($primarySizeSelect) ? customLength : "",
      productPrice: selectedProductPriceValue,
      quantity: selectedProductQuantityValue,
      discountPercentage: discountPercentageValue,
      totalPrice: totalPriceValue,
      color: selectedColorValue,
      backgroundColor: backgroundColorValue,
      bespokeColor: bespokeOptionValue,
      imageUrl: imageUrl,
      productVariantId: selectedSizeOptionVariantId || resolveCurrentVariantId(),
      /* New (06-May-2026): product_id sent direct from the page so the
         Function App's canonical_normalize doesn't have to derive it from
         variant_id alone. The previous derivation was mapping outdoor
         variants to the indoor parent product because the lookup table
         didn't reflect the outdoor/circular product registrations. */
      productId: productId,
      productHandle: productHandle,
    };

    return item;
  }

  function isSizePlaceholderValue(sizeValue) {
    const normalizedValue = safeTrim(sizeValue).toLowerCase();
    return (
      !normalizedValue ||
      normalizedValue === "select size" ||
      normalizedValue === "select an option"
    );
  }

  function getCurrentSizeSelectionData() {
    const $sizeSelect = getPrimarySizeSelect();
    if ($sizeSelect.length === 0) {
      return null;
    }

    const selectedSizeValue = safeTrim(
      $sizeSelect.find(".cw-product-bundle__variant-selected .cw-product-bundle__variant-text").text()
    );
    if (isSizePlaceholderValue(selectedSizeValue)) {
      return null;
    }

    const selectedProductPriceValue = safeTrim(
      $sizeSelect
        .find(".cw-product-bundle__variant-selected .cw-product-bundle__variant-price")
        .first()
        .text()
    );
    const selectedVariantId = resolveSizeSelectVariantId($sizeSelect);
    const isCustomSize = isCustomSizeSelectedOnSizeSelect($sizeSelect);

    return {
      size: selectedSizeValue,
      customWidth: isCustomSize ? safeTrim($('input[name="width"]').val()) : "",
      customLength: isCustomSize ? safeTrim($('input[name="length"]').val()) : "",
      productPrice: selectedProductPriceValue,
      productVariantId: selectedVariantId || resolveCurrentVariantId(),
    };
  }

  function getSelectedSizeDataList() {
    const selections = [];
    const $rows =
      logoWizardState.$sizeRowsContainer.length > 0
        ? logoWizardState.$sizeRowsContainer.children(".logo-mat-wizard__size-row")
        : $();

    if ($rows.length > 0) {
      $rows.each(function () {
        const $sizeSelect = $(this).find(".cw-product-bundle__variant-select").first();
        const selectedSizeValue = safeTrim(
          $sizeSelect
            .find(".cw-product-bundle__variant-selected .cw-product-bundle__variant-text")
            .text()
        );
        if (isSizePlaceholderValue(selectedSizeValue)) {
          return;
        }

        const selectedProductPriceValue = safeTrim(
          $sizeSelect
            .find(".cw-product-bundle__variant-selected .cw-product-bundle__variant-price")
            .first()
            .text()
        );
        const selectedVariantId = resolveSizeSelectVariantId($sizeSelect);
        const isCustomSize = isCustomSizeSelectedOnSizeSelect($sizeSelect);

        selections.push({
          size: selectedSizeValue,
          customWidth: isCustomSize ? safeTrim($('input[name="width"]').val()) : "",
          customLength: isCustomSize ? safeTrim($('input[name="length"]').val()) : "",
          productPrice: selectedProductPriceValue,
          productVariantId: selectedVariantId || resolveCurrentVariantId(),
        });
      });
      return selections;
    }

    const currentSelection = getCurrentSizeSelectionData();
    return currentSelection ? [currentSelection] : [];
  }

  function normalizeQuantityValue(value) {
    const parsed = parseInt(value, 10);
    if (!Number.isFinite(parsed) || Number.isNaN(parsed)) {
      return 1;
    }
    return Math.max(parsed, 1);
  }

  function syncQuantitySelections(sizeCount) {
    const targetCount = Math.max(sizeCount, 0);
    const nextSelections = [];
    for (let index = 0; index < targetCount; index += 1) {
      const existingQty = logoWizardState.quantitySelections[index];
      nextSelections.push(normalizeQuantityValue(existingQty || 1));
    }
    logoWizardState.quantitySelections = nextSelections;
  }

  function getQuantityPricingForSize(sizeData, quantity) {
    const qtyValue = normalizeQuantityValue(quantity);
    const basePriceValue = parseCurrencyAmount(sizeData.productPrice);
    const safeBasePriceValue = basePriceValue !== null ? basePriceValue : 0;
    const tiers = getQuantityDiscountTiers();
    const discountPercentValue = getDiscountPercentForQty(qtyValue, tiers);
    const discountedUnitValue = roundToTwo(
      safeBasePriceValue * (1 - discountPercentValue / 100)
    );

    return {
      quantity: qtyValue,
      discountPercentValue,
      discountPercentageText:
        discountPercentValue > 0 ? `Save ${discountPercentValue}%` : "",
      productPriceText: formatMoneyAmount(safeBasePriceValue),
      totalPriceText:
        discountedUnitValue !== null
          ? formatMoneyAmount(discountedUnitValue)
          : formatMoneyAmount(safeBasePriceValue),
    };
  }

  function renderQuantityRows() {
    if (!logoWizardState.$quantityList.length) {
      return;
    }

    const sizeSelections = getSelectedSizeDataList();
    syncQuantitySelections(sizeSelections.length);
    logoWizardState.$quantityList.empty();

    if (!sizeSelections.length) {
      logoWizardState.$quantityList.append(
        '<p class="logo-mat-wizard__qty-empty">Select at least one size before choosing quantities.</p>'
      );
      if (logoWizardState.$volumeInfoBar.length > 0) {
        logoWizardState.$volumeInfoBar.removeClass("is-visible").hide();
      }
      return;
    }

    sizeSelections.forEach((sizeData, index) => {
      const quantityValue = logoWizardState.quantitySelections[index] || 1;
      const pricing = getQuantityPricingForSize(sizeData, quantityValue);
      const sizeLabel = safeTrim(sizeData.customWidth)
        ? `${sizeData.customWidth}cm x ${sizeData.customLength}cm`
        : safeTrim(sizeData.size);

      const saveMarkup = pricing.discountPercentageText
        ? `<p class="logo-mat-wizard__qty-save">${pricing.discountPercentageText}</p>`
        : "";

      logoWizardState.$quantityList.append(`
        <div class="logo-mat-wizard__qty-row" data-qty-index="${index}">
          <div class="logo-mat-wizard__qty-size">${sizeLabel}</div>
          <div class="logo-mat-wizard__qty-controls">
            <button type="button" class="logo-mat-wizard__qty-button" data-action="decrease" aria-label="Decrease quantity for ${sizeLabel}">-</button>
            <span class="logo-mat-wizard__qty-value" aria-live="polite">${pricing.quantity}</span>
            <button type="button" class="logo-mat-wizard__qty-button" data-action="increase" aria-label="Increase quantity for ${sizeLabel}">+</button>
          </div>
          <div class="logo-mat-wizard__qty-price">
            <p class="logo-mat-wizard__qty-price-main"><strong>${pricing.totalPriceText}</strong> <span>+ VAT Each</span></p>
            ${saveMarkup}
          </div>
        </div>
      `);
    });

    /* Multi-buy nudge/save banner (journey-card). Uses the REAL discount tiers
       (data-save-percentage on the quantity options) applied to the total
       quantity across all size lines. Only shown when a discount programme
       exists (tier-2 > 0); mirrors the per-line "Save X%" the engine already
       renders on each row. Re-rendered here on every quantity change. */
    const nudgeTiers = getQuantityDiscountTiers();
    const nudgeT2 = nudgeTiers[2] || 0;
    const nudgeT3 = nudgeTiers[3] || 0;
    const nudgeT4 = nudgeTiers[4] || 0;
    if (nudgeT2 > 0) {
      /* Discounts are applied PER LINE by that line's quantity, so base the
         banner on the largest single-line quantity — that keeps "X% off
         applied" truthful (at least one line actually gets it) even with
         multiple sizes. */
      const bestLineQty = logoWizardState.quantitySelections.reduce(
        (max, qtyValue) => Math.max(max, normalizeQuantityValue(qtyValue || 1)),
        0
      );
      const currentNudgeRate = getDiscountPercentForQty(bestLineQty, nudgeTiers);
      let nudgeType = "";
      let nudgeText = "";
      if (bestLineQty < 2) {
        nudgeType = "nudge";
        nudgeText = `Add 1 more mat and save ${nudgeT2}% on your order`;
      } else if (bestLineQty === 2 && nudgeT3 > currentNudgeRate) {
        nudgeType = "save";
        nudgeText = `${currentNudgeRate}% off applied — add 1 more for ${nudgeT3}%`;
      } else if (bestLineQty === 3 && nudgeT4 > currentNudgeRate) {
        nudgeType = "save";
        nudgeText = `${currentNudgeRate}% off applied — add 1 more for ${nudgeT4}%`;
      } else if (currentNudgeRate > 0) {
        nudgeType = "save";
        nudgeText = `${currentNudgeRate}% off applied — that's our best multi-buy price!`;
      }
      if (nudgeText) {
        const nudgeIcon =
          nudgeType === "save"
            ? '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>'
            : '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="13" rx="1"/><path d="M3 12h18M12 8v13M12 8H7.5a2.5 2.5 0 0 1 0-5C11 3 12 8 12 8zM12 8h4.5a2.5 2.5 0 0 0 0-5C13 3 12 8 12 8z"/></svg>';
        logoWizardState.$quantityList.append(
          `<div class="logo-mat-wizard__qty-nudge logo-mat-wizard__qty-nudge--${nudgeType}">${nudgeIcon}<span>${nudgeText}</span></div>`
        );
      }
    }

    if (logoWizardState.$volumeInfoBar.length > 0) {
      const defaultVolumeInfoEnabled =
        safeTrim(logoWizardState.$volumeInfoBar.attr("data-default-enabled")).toLowerCase() ===
        "true";
      const showVolumeInfo =
        defaultVolumeInfoEnabled ||
        logoWizardState.quantitySelections.some(
        (qtyValue) => normalizeQuantityValue(qtyValue) >= 5
      );
      logoWizardState.$volumeInfoBar.toggleClass("is-visible", showVolumeInfo);
      if (showVolumeInfo) {
        logoWizardState.$volumeInfoBar.show();
      } else {
        logoWizardState.$volumeInfoBar.hide();
      }
    }
  }

  function setWizardBackButtonMode(mode) {
    if (!logoWizardState.$backButton.length) {
      return;
    }
    const isStartOver = mode === "start-over";
    logoWizardState.$backButton
      .toggleClass("logo-mat-wizard__nav-button--start-over", isStartOver)
      .text(isStartOver ? "Start Over" : "Back");
  }

  function resetWizardForNewSubmission() {
    logoWizardState.isSubmissionComplete = false;
    setWizardBackButtonMode("back");

    const $checkoutForm = $(".secure-checkout__form");
    $checkoutForm.removeClass("form-submit-success is-submitting");
    $checkoutForm.find("input").removeClass("invalid");
    $checkoutForm.find(".error-message").hide();
    $checkoutForm.find("#firstName, #surname, #email, #company, #phone").val("");

    setInstantProofDebugMessage("");
    isCheckoutSubmitting = false;
    setCheckoutSubmitState(false);

    if (logoWizardState.$sizeRowsContainer.length > 0) {
      const $rows = logoWizardState.$sizeRowsContainer.children(".logo-mat-wizard__size-row");
      $rows.slice(1).remove();
      const $firstSelect = logoWizardState.$sizeRowsContainer
        .children(".logo-mat-wizard__size-row")
        .first()
        .find(".cw-product-bundle__variant-select")
        .first();
      resetSizeSelectToPlaceholder($firstSelect);
      refreshSizeRowsState();
    } else {
      resetSizeSelectionToPlaceholder();
    }

    logoWizardState.quantitySelections = [];
    if (logoWizardState.$volumeInfoBar.length > 0) {
      logoWizardState.$volumeInfoBar.removeClass("is-visible").hide();
    }

    showWizardStep(0, { skipValidation: true });
  }

  function getQuantityDataForSize(sizeData, index) {
    const quantityValue = logoWizardState.quantitySelections[index] || 1;
    const pricing = getQuantityPricingForSize(sizeData, quantityValue);
    return {
      quantity: String(pricing.quantity),
      discountPercentage: pricing.discountPercentageText,
      totalPrice: pricing.totalPriceText,
      productPrice: safeTrim(sizeData.productPrice) || pricing.productPriceText,
    };
  }

  function buildDesignItemFromBaseAndSize(baseItem, sizeData, quantityData) {
    if (!baseItem || !sizeData) {
      return baseItem;
    }

    return {
      ...baseItem,
      size: safeTrim(sizeData.size),
      customWidth: safeTrim(sizeData.customWidth),
      customLength: safeTrim(sizeData.customLength),
      productPrice:
        safeTrim((quantityData && quantityData.productPrice) || sizeData.productPrice) ||
        baseItem.productPrice,
      quantity:
        safeTrim(quantityData && quantityData.quantity) || safeTrim(baseItem.quantity) || "1",
      discountPercentage:
        safeTrim(quantityData && quantityData.discountPercentage) ||
        safeTrim(baseItem.discountPercentage),
      totalPrice:
        safeTrim(quantityData && quantityData.totalPrice) ||
        safeTrim(baseItem.totalPrice) ||
        safeTrim((quantityData && quantityData.productPrice) || sizeData.productPrice),
      productVariantId: sizeData.productVariantId || baseItem.productVariantId,
    };
  }

  function getQueuedSizeDesignItems(baseItem) {
    const sizeSelections = getSelectedSizeDataList();
    if (!baseItem || !sizeSelections.length) {
      return [];
    }

    return sizeSelections.map((sizeData, index) =>
      buildDesignItemFromBaseAndSize(
        baseItem,
        sizeData,
        getQuantityDataForSize(sizeData, index)
      )
    );
  }

  function getWizardSummaryEntries() {
    const currentItem = buildCurrentDesignItem();
    const sizeItems = getQueuedSizeDesignItems(currentItem);

    if (!sizeItems.length) {
      if (isSizePlaceholderValue(currentItem.size)) {
        return [];
      }
      return [{ source: "current", index: 0, item: currentItem }];
    }

    return sizeItems.map((item, index) => ({
      source: "current",
      index,
      item,
    }));
  }

  function resetSizeSelectToPlaceholder($sizeSelect) {
    if ($sizeSelect.length === 0) {
      return;
    }

    $sizeSelect
      .find(".cw-product-bundle__variant-selected")
      .html(
        '<span class="cw-product-bundle__variant-text">Select Size</span><span class="cw-product-bundle__variant-price"></span>'
      );
    $sizeSelect.find('input[type="hidden"]').val("");
    $sizeSelect.find(".cw-product-bundle__variant-option").removeClass("active-status");
    $sizeSelect.find(".cw-product-bundle__variant-options").hide();
    $sizeSelect.removeClass("is-open");
    $sizeSelect.removeClass("is-custom-size-selected");
    $sizeSelect.removeAttr("data-selected-variant-id");
    $sizeSelect.removeAttr("data-selected-option-text");
    $sizeSelect.removeAttr("data-selected-option-raw-text");
    $sizeSelect.removeAttr("data-selected-is-custom-size");
    updateCustomSizeLabels();
  }

  function resetSizeSelectionToPlaceholder() {
    resetSizeSelectToPlaceholder(getPrimarySizeSelect());

    $(".custom-width-input-field").hide();
    $('input[name="width"], input[name="length"]').val("");
    $(
      ".size-error-message, .size-error-message--max, .size-error-message--required, .size-error-message-length--required, .size-error-message--min"
    ).hide();
  }

  function refreshSizeRowsState() {
    if (!logoWizardState.$sizeRowsContainer.length) {
      return;
    }

    const $sizeRows = logoWizardState.$sizeRowsContainer.children(".logo-mat-wizard__size-row");
    const canRemoveRows = $sizeRows.length > 1;
    $sizeRows.each(function () {
      $(this)
        .find(".logo-mat-wizard__size-row-remove")
        .prop("disabled", !canRemoveRows)
        .attr("aria-disabled", canRemoveRows ? "false" : "true");
    });
  }

  function getDesignItemsForSubmission() {
    if (!logoWizardState.enabled) {
      return [buildCurrentDesignItem()];
    }

    const currentItem = buildCurrentDesignItem();
    const sizeSelections = getSelectedSizeDataList();
    if (!sizeSelections.length) {
      return isSizePlaceholderValue(currentItem.size) ? [] : [currentItem];
    }

    return sizeSelections.map((sizeData, index) =>
      buildDesignItemFromBaseAndSize(
        currentItem,
        sizeData,
        getQuantityDataForSize(sizeData, index)
      )
    );
  }

  function isDesignStepAvailable($step) {
    if (!$step || $step.length === 0) {
      return false;
    }
    if ($step.hasClass("hex_color_option_wrapper")) {
      return $('input[name="bespoke-option"]:checked').val() === "yes";
    }
    if ($step.hasClass("color_selection_options_wrapper")) {
      return $('input[name="bespoke-option"]:checked').val() !== "yes";
    }
    return true;
  }

  function getWizardSteps() {
    if (!logoWizardState.enabled) {
      return [];
    }

    const filteredDesignSteps = logoWizardState.$designSteps
      .filter(function () {
        return isDesignStepAvailable($(this));
      })
      .toArray();

    const quantitySteps = [];
    const colorSteps = [];
    const nonReorderedSteps = [];

    filteredDesignSteps.forEach((stepElement) => {
      const $step = $(stepElement);
      if ($step.find(".main-product__quantity-option").length > 0) {
        quantitySteps.push(stepElement);
        return;
      }
      if (
        $step.hasClass("color_selection_options_wrapper") ||
        $step.hasClass("hex_color_option_wrapper")
      ) {
        colorSteps.push(stepElement);
        return;
      }
      nonReorderedSteps.push(stepElement);
    });

    /* Journey-card (03-Jul-2026): lead with Orientation, then Location.
       The markup renders Location (backing) before Orientation, and this
       list is otherwise in DOM order — so pull the orientation + backing
       steps to the front (orientation first) without moving the Liquid
       blocks. Every other non-reordered step (size, upload, …) keeps its
       relative order, and the post-size insertion of quantity + colour
       below still works because the size step stays in this list. */
    const orientationSteps = [];
    const backingSteps = [];
    const otherNonReorderedSteps = [];
    nonReorderedSteps.forEach((stepElement) => {
      const $step = $(stepElement);
      if ($step.find(".main-product__orientation-option").length > 0) {
        orientationSteps.push(stepElement);
      } else if ($step.find(".main-product__backing-option").length > 0) {
        backingSteps.push(stepElement);
      } else {
        otherNonReorderedSteps.push(stepElement);
      }
    });
    const orderedNonReorderedSteps = [
      ...orientationSteps,
      ...backingSteps,
      ...otherNonReorderedSteps,
    ];

    const designStepElements = [];
    let insertedPostSizeSteps = false;

    orderedNonReorderedSteps.forEach((stepElement) => {
      designStepElements.push(stepElement);

      if (!insertedPostSizeSteps) {
        const $step = $(stepElement);
        if ($step.find(".main-product__size-option").length > 0) {
          designStepElements.push(...quantitySteps, ...colorSteps);
          insertedPostSizeSteps = true;
        }
      }
    });

    if (!insertedPostSizeSteps) {
      designStepElements.push(...quantitySteps, ...colorSteps);
    }

    if (logoWizardState.$detailsStep.length > 0) {
      const detailsStep = logoWizardState.$detailsStep.get(0);
      if (detailsStep) {
        designStepElements.push(detailsStep);
      }
    }

    return designStepElements;
  }

  function updateWizardSummary() {
    if (!logoWizardState.enabled) {
      return;
    }

    const summaryEntries = getWizardSummaryEntries();
    const allItems = summaryEntries.map((entry) => entry.item);
    const totalItems = allItems.length;

    logoWizardState.$summaryList.empty();
    summaryEntries.forEach((entry, index) => {
      const item = entry.item;
      const sizeText = item.customWidth
        ? `${item.customWidth}cm x ${item.customLength}cm`
        : item.size || "Size to be confirmed";
      const orientationText = item.orientation || "orientation not selected";
      const bgColorText = item.backgroundColor || "default background";

      logoWizardState.$summaryList.append(`
        <li class="logo-mat-wizard__summary-item">
          <div class="logo-mat-wizard__summary-item-main">
            <strong>Design ${index + 1}:</strong> ${sizeText} | ${orientationText} | ${bgColorText}
          </div>
          <button type="button" class="logo-mat-wizard__summary-remove" data-item-source="${entry.source}" data-item-index="${entry.index}" aria-label="Remove design ${index + 1}" title="Remove this design">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M9 3h6l1 2h4v2H4V5h4l1-2zm1 7h2v8h-2v-8zm4 0h2v8h-2v-8zM7 10h2v8H7v-8zm-1 10h12l1-13H5l1 13z"></path>
            </svg>
          </button>
        </li>
      `);
    });

    logoWizardState.$continueDetailsButton.prop("disabled", totalItems === 0);

    if (totalItems === 0) {
      logoWizardState.$summaryHelpText
        .text("Add at least one design before continuing to your details.")
        .removeClass("logo-mat-wizard__summary-help--instant")
        .addClass("logo-mat-wizard__summary-help--manual");
      return;
    }

    if (totalItems > 1) {
      logoWizardState.$summaryHelpText
        .text(
          `${totalItems} designs selected. This submission will be routed as manual proof.`
        )
        .removeClass("logo-mat-wizard__summary-help--instant")
        .addClass("logo-mat-wizard__summary-help--manual");
    } else {
      logoWizardState.$summaryHelpText
        .text("Single design selected. This submission can use instant proof.")
        .removeClass("logo-mat-wizard__summary-help--manual")
        .addClass("logo-mat-wizard__summary-help--instant");
    }
  }

  function validateCustomSizeStep() {
    const hasCustomSizeSelection = getSelectedSizeDataList().some((item) => {
      const sizeLabel = safeTrim(item.size).toLowerCase();
      return sizeLabel.indexOf("custom") > -1 || sizeLabel.indexOf("bespoke") > -1;
    });

    if (!hasCustomSizeSelection) {
      $(".size-error-message, .size-error-message--max").hide();
      return true;
    }

    let isValid = true;
    const widthValue = parseFloat($('input[name="width"]').val());
    const lengthValue = parseFloat($('input[name="length"]').val());
    const minWidthValue = 40;
    const maxWidthValue = 200;
    const minLengthValue = 40;
    const maxLengthValue = 700;

    /* Errors now live below the inputs (full width), not inside the columns —
       target them by their distinct classes. */
    $(".size-error-message--min-width, .size-error-message--max, .size-error-message--length").hide();

    if (isNaN(widthValue) || widthValue < minWidthValue) {
      isValid = false;
      $(".size-error-message--min-width").show();
    }

    if (!isNaN(widthValue) && widthValue > maxWidthValue) {
      isValid = false;
      $(".size-error-message--max").show();
    }

    if (isNaN(lengthValue) || lengthValue < minLengthValue || lengthValue > maxLengthValue) {
      isValid = false;
      $(".size-error-message--length").show();
    }

    return isValid;
  }

  function validateStep(stepElement) {
    const $step = $(stepElement);
    if ($step.length === 0) {
      return true;
    }

    const $error = $step.find(".logo-mat-wizard__step-error");
    $error.hide().text("");
    /* Reveal a step error even if it sits below the fold of a scrolling step
       body (e.g. the tall Size step inside the modal). Scrolls the nearest
       scroll container the minimum needed. */
    const revealStepError = function () {
      if ($error[0] && typeof $error[0].scrollIntoView === "function") {
        $error[0].scrollIntoView({ block: "nearest" });
      }
    };

    if ($step.find(".main-product__size-option").length > 0) {
      const selectedSizes = getSelectedSizeDataList();
      if (selectedSizes.length === 0) {
        $error.text("Please choose a size before continuing.").show();
        revealStepError();
        return false;
      }

      if (!validateCustomSizeStep()) {
        $error
          .text("Please check your custom dimensions before continuing.")
          .show();
        return false;
      }
    }

    if ($step.find(".main-product__quantity-option").length > 0) {
      const selectedSizes = getSelectedSizeDataList();
      if (selectedSizes.length === 0) {
        $error.text("Please choose at least one size before setting quantity.").show();
        revealStepError();
        return false;
      }
      syncQuantitySelections(selectedSizes.length);
      const hasInvalidQty = logoWizardState.quantitySelections.some(
        (qtyValue) => normalizeQuantityValue(qtyValue) < 1
      );
      if (hasInvalidQty) {
        $error.text("Please choose a valid quantity for each size.").show();
        revealStepError();
        return false;
      }
    }

    if ($step.hasClass("hex_color_option_wrapper")) {
      const colorValue = safeTrim($("#color-option-input").val());
      if (!colorValue) {
        $error.text("Please enter a bespoke background colour.").show();
        revealStepError();
        return false;
      }
    }

    if ($step.find('input[name="background-color-swatch"]').length > 0) {
      const selectedBackground = $('input[name="background-color-swatch"]:checked');
      if (selectedBackground.length > 0 && selectedBackground.attr("id") === "background-custom-colour") {
        const customHexValue = safeTrim($("#backgroundCustomColourHex").val());
        if (!/^[0-9A-Fa-f]{6}$/.test(customHexValue)) {
          $error.text("Please enter a valid 6-digit hex colour before continuing.").show();
          revealStepError();
          return false;
        }
      }
    }

    return true;
  }

  function isForceManualMode() {
    return (
      safeTrim(
        logoWizardState.$customiseSelection &&
          logoWizardState.$customiseSelection.attr("data-force-manual")
      ) === "true"
    );
  }

  /* Force-manual submission: turn the green header band into a completion
     state ("Thanks — we've got your design" + all steps ticked). Called after
     showWizardStep so it isn't overwritten. */
  function renderManualCompletionBand() {
    /* Completion takeover: a class the CSS uses to hide the Back/Next nav so
       the finished state can't be navigated. Set even if the band lookup below
       bails, so nav is always hidden on a completed manual submission. */
    if (logoWizardState.$customiseSelection) {
      logoWizardState.$customiseSelection.addClass("is-manual-complete");
    }
    if (!logoWizardState.$bandTitle || logoWizardState.$bandTitle.length === 0) {
      return;
    }
    logoWizardState.$bandTitle.text("Thanks — we've got your design");
    if (logoWizardState.$bandSub && logoWizardState.$bandSub.length > 0) {
      logoWizardState.$bandSub
        .text("Your request is now with our design team.")
        .show();
    }
    logoWizardState.$customiseSelection
      .find(".logo-mat-wizard__eyebrow-step")
      .hide();
    if (logoWizardState.$progressDots && logoWizardState.$progressDots.length > 0) {
      var totalSteps = getWizardSteps().length || 0;
      var checkSvg =
        '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
      var dotsMarkup = "";
      for (var d = 0; d < totalSteps; d++) {
        dotsMarkup +=
          '<span class="logo-mat-wizard__progress-dot is-active is-done" aria-hidden="true">' +
          checkSvg +
          "</span>";
      }
      logoWizardState.$progressDots.html(dotsMarkup);
    }
    if (logoWizardState.$progressBarFill && logoWizardState.$progressBarFill.length > 0) {
      logoWizardState.$progressBarFill.css("width", "100%");
    }
  }

  function showWizardStep(index, options) {
    if (!logoWizardState.enabled) {
      return;
    }

    const config = options || {};
    const allSteps = getWizardSteps();
    if (allSteps.length === 0) {
      return;
    }

    let nextIndex = index;
    if (nextIndex < 0) {
      nextIndex = 0;
    }
    if (nextIndex > allSteps.length - 1) {
      nextIndex = allSteps.length - 1;
    }

    if (!config.skipValidation) {
      const currentStep = allSteps[logoWizardState.currentStepIndex];
      if (nextIndex > logoWizardState.currentStepIndex && !validateStep(currentStep)) {
        return;
      }
    }

    logoWizardState.currentStepIndex = nextIndex;

    logoWizardState.$designSteps.addClass("logo-mat-wizard__step--inactive");
    logoWizardState.$reviewStep.addClass("logo-mat-wizard__step--inactive");
    logoWizardState.$detailsStep.addClass("logo-mat-wizard__step--inactive");

    const activeStep = $(allSteps[logoWizardState.currentStepIndex]);
    activeStep.removeClass("logo-mat-wizard__step--inactive");

    /* Journey-card: mirror the active step's heading + subheading into the
       green header band. The per-step .main-product__select-heading is
       hidden via CSS, so this keeps the section-setting-driven copy as the
       single source of truth while showing it in the band (03-Jul-2026). */
    if (logoWizardState.$bandTitle && logoWizardState.$bandTitle.length > 0) {
      const $activeTitle = activeStep.find(".main-product__select-text").first();
      logoWizardState.$bandTitle.text(
        $activeTitle.length > 0 ? safeTrim($activeTitle.text()) : ""
      );
      const $activeSub = activeStep.find(".logo-mat-wizard__step-subheading").first();
      const activeSubText = $activeSub.length > 0 ? safeTrim($activeSub.text()) : "";
      logoWizardState.$bandSub.text(activeSubText).toggle(activeSubText.length > 0);
    }

    const isDetailsStep = activeStep.is(logoWizardState.$detailsStep);
    const isLastStep = logoWizardState.currentStepIndex === allSteps.length - 1;

    if (logoWizardState.isSubmissionComplete) {
      setWizardBackButtonMode("start-over");
      logoWizardState.$backButton.removeClass("logo-mat-wizard__nav-button--hidden");
    } else {
      setWizardBackButtonMode("back");
      logoWizardState.$backButton.toggleClass(
        "logo-mat-wizard__nav-button--hidden",
        logoWizardState.currentStepIndex === 0
      );
    }

    if (isDetailsStep) {
      logoWizardState.$nextButton.addClass("logo-mat-wizard__nav-button--hidden");
    } else {
      logoWizardState.$nextButton.removeClass("logo-mat-wizard__nav-button--hidden");
      logoWizardState.$nextButton.text(isLastStep ? "Continue" : "Next");
    }

    logoWizardState.$progressCurrent.text(logoWizardState.currentStepIndex + 1);
    logoWizardState.$progressTotal.text(allSteps.length);
    if (logoWizardState.$progressBarFill.length > 0) {
      const progressPercent =
        allSteps.length > 1
          ? (logoWizardState.currentStepIndex / (allSteps.length - 1)) * 100
          : allSteps.length === 1
          ? 100
          : 0;
      logoWizardState.$progressBarFill.css("width", `${progressPercent}%`);
    }
    if (logoWizardState.$progressDots.length > 0) {
      const totalSteps = allSteps.length;

      /* Segmented stepper (journey-card): each dot is a disc showing a
         check when done, its number when current/upcoming. `is-active`
         (index <= current) is retained for backward-compat with older
         CSS; `is-done` / `is-current` drive the gold disc styling. Always
         rebuilt so the inner check/number content stays correct. */
      const currentStepIdx = logoWizardState.currentStepIndex;
      const stepCheckSvg =
        '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
      const dotsMarkup = Array.from({ length: totalSteps }, (_, dotIndex) => {
        let stateClass = "";
        let inner = String(dotIndex + 1);
        if (dotIndex < currentStepIdx) {
          stateClass = " is-active is-done";
          inner = stepCheckSvg;
        } else if (dotIndex === currentStepIdx) {
          stateClass = " is-active is-current";
        }
        return `<span class="logo-mat-wizard__progress-dot${stateClass}" aria-hidden="true">${inner}</span>`;
      }).join("");
      logoWizardState.$progressDots.html(dotsMarkup);
    }

    const isQuantityStep = activeStep.find(".main-product__quantity-option").length > 0;
    if (isQuantityStep) {
      renderQuantityRows();
    }
    if (!isQuantityStep && logoWizardState.$volumeInfoBar.length > 0) {
      logoWizardState.$volumeInfoBar.removeClass("is-visible").hide();
    }
  }

  function initLogoWizard() {
    // Was: only ran on body.pg-eq-custom-product. The body class is
    // `pg-{{ template.suffix }}` (set in layout/eq-theme.liquid), so this
    // check excluded every OTHER logo-mat template — schools (suffix
    // eq-custom-schools), outdoor (eq-custom-outdoor-logo-mat), circular,
    // hotel, restaurant, motorcycle, racing-team. They all share the same
    // main-product.liquid section + the wizard markup, but with the gate
    // tightly coupled to `eq-custom-product`, the wizard never received
    // `.is-wizard-ready`, and CSS kept it `visibility: hidden`. Result:
    // the form vanished on every non-default logo-mat template.
    //
    // Loosened to ANY `pg-eq-custom-` prefix so all logo-mat templates
    // share the same wizard initialisation. If a specific template needs
    // the wizard suppressed, do it via a more specific check downstream
    // rather than at the top-level gate.
    const bodyClass = ($("body").attr("class") || "");
    if (!/\bpg-eq-custom-/.test(bodyClass)) {
      return;
    }

    const $customiseSelection = $(".main-product__customise-selection").first();
    const $checkout = $("#secure-checkout");
    if ($customiseSelection.length === 0 || $checkout.length === 0) {
      return;
    }

    const $designSteps = $customiseSelection
      .children(".main-product__customise-wrapper")
      .not(".logo-mat-wizard__review-step, .logo-mat-wizard__details-step");

    if ($designSteps.length === 0) {
      return;
    }

    logoWizardState.enabled = true;
    logoWizardState.$customiseSelection = $customiseSelection;
    logoWizardState.$designSteps = $designSteps;
    logoWizardState.$volumeInfoBar = $customiseSelection.children(".volume-info-bar");

    logoWizardState.$customiseSelection.addClass("logo-mat-wizard is-wizard-ready");
    $(".main-product__right").addClass("logo-mat-wizard-ready");

    logoWizardState.$designSteps.addClass("logo-mat-wizard__step");

    const wizardHelpHeading = safeTrim(
      logoWizardState.$customiseSelection.attr("data-wizard-help-heading")
    );
    const wizardHelpText = safeTrim(
      logoWizardState.$customiseSelection.attr("data-wizard-help-text")
    );
    const wizardHelpPhone = safeTrim(
      logoWizardState.$customiseSelection.attr("data-wizard-help-phone")
    );
    const wizardHelpEmail = safeTrim(
      logoWizardState.$customiseSelection.attr("data-wizard-help-email")
    );
    const wizardHelpPhoneHref = wizardHelpPhone.replace(/[^0-9+]/g, "");
    /* Need-help block (revised 03-Jun-2026).
       Layout: heading → action buttons (Email + Chat) → phone line.
       Positioned once per wizard, BELOW the Next/Back navigation
       (see the append-after-nav call later in this function), so it
       doesn't crowd the step content. The "Chat with us" button
       carries `js-ch-chat-open`, which the `chat-launcher` snippet
       (rendered on the PDP) hooks via delegated listener to open the
       Klaviyo Live Chat widget. */
    const wizardHelpEmailSubject = "Logo Mat Enquiry";
    const wizardHelpMarkup =
      wizardHelpHeading || wizardHelpText || wizardHelpPhone || wizardHelpEmail
        ? `
          <div class="logo-mat-wizard__need-help">
            ${
              wizardHelpHeading
                ? `<p class="logo-mat-wizard__need-help-title">${escapeHtml(
                    wizardHelpHeading
                  )}</p>`
                : ""
            }
            ${
              wizardHelpEmail || wizardHelpPhone
                ? `<div class="logo-mat-wizard__need-help-actions">
                    ${
                      wizardHelpEmail
                        ? `<a href="mailto:${escapeHtml(wizardHelpEmail)}?subject=${encodeURIComponent(wizardHelpEmailSubject)}" class="logo-mat-wizard__need-help-btn logo-mat-wizard__need-help-btn--email">
                            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 7l9 6 9-6"/></svg>
                            <span>Enquire by Email</span>
                          </a>`
                        : ""
                    }
                    <button type="button" class="logo-mat-wizard__need-help-btn logo-mat-wizard__need-help-btn--chat js-ch-chat-open">
                      <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>
                      <span>Chat with us</span>
                    </button>
                    ${
                      wizardHelpPhone
                        ? `<a href="tel:${escapeHtml(wizardHelpPhoneHref || wizardHelpPhone)}" class="logo-mat-wizard__need-help-btn logo-mat-wizard__need-help-btn--phone">
                            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.9.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
                            <span>${escapeHtml(wizardHelpPhone)}</span>
                          </a>`
                        : ""
                    }
                  </div>`
                : ""
            }
          </div>
        `
        : "";

    const $quantityStep = logoWizardState.$designSteps
      .filter(function () {
        return $(this).find(".main-product__quantity-option").length > 0;
      })
      .first();
    logoWizardState.$quantityStep = $quantityStep;

    if (logoWizardState.$volumeInfoBar.length > 0 && $quantityStep.length > 0) {
      $quantityStep
        .find(".main-product__select-block")
        .first()
        .append(logoWizardState.$volumeInfoBar.addClass("logo-mat-wizard__volume-info"));
      logoWizardState.$volumeInfoBar.hide();
    }

    if ($quantityStep.length > 0) {
      const $quantityHeading = $quantityStep.find(".main-product__select-heading").first();
      if ($quantityHeading.length > 0) {
        const $quantityHeadingText = $quantityHeading.find(".main-product__select-text").first();
        if ($quantityHeadingText.length > 0) {
          $quantityHeadingText.text("Select Quantity");
        }

        let $quantitySubheading = $quantityHeading.find(".logo-mat-wizard__step-subheading").first();
        if ($quantitySubheading.length === 0) {
          $quantitySubheading = $('<p class="logo-mat-wizard__step-subheading"></p>');
          $quantityHeading.append($quantitySubheading);
        }
        if ($quantitySubheading.parent().hasClass("logo-mat-wizard__heading-row")) {
          $quantityHeading.append($quantitySubheading);
        }
        $quantitySubheading.text("Set the quantity for each selected size.");
      }

      const $quantityBlock = $quantityStep.find(".main-product__select-block").first();
      if ($quantityBlock.find(".logo-mat-wizard__quantity-list").length === 0) {
        $quantityBlock.prepend('<div class="logo-mat-wizard__quantity-list" aria-live="polite"></div>');
      }
      logoWizardState.$quantityList = $quantityBlock.find(".logo-mat-wizard__quantity-list").first();
      $quantityStep.find(".main-product__quantity-option, .custom-width-input-field--qty").hide();

      $quantityStep.on("click", ".logo-mat-wizard__qty-button", function () {
        const rowIndex = parseInt($(this).closest(".logo-mat-wizard__qty-row").attr("data-qty-index") || "-1", 10);
        if (Number.isNaN(rowIndex) || rowIndex < 0) {
          return;
        }
        const action = safeTrim($(this).attr("data-action")).toLowerCase();
        const currentQty = normalizeQuantityValue(logoWizardState.quantitySelections[rowIndex] || 1);
        logoWizardState.quantitySelections[rowIndex] =
          action === "decrease"
            ? Math.max(currentQty - 1, 1)
            : currentQty + 1;
        renderQuantityRows();
      });
    }

    logoWizardState.$designSteps.each(function () {
      if ($(this).find(".logo-mat-wizard__step-error").length === 0) {
        $(this)
          .find(".main-product__customise-block")
          .first()
          .append('<p class="logo-mat-wizard__step-error" style="display:none;"></p>');
      }
    });

    const $sizeStep = logoWizardState.$designSteps
      .filter(function () {
        return $(this).find(".main-product__size-option").length > 0;
      })
      .first();
    logoWizardState.$sizeStep = $sizeStep;
    if ($sizeStep.length > 0) {
      const $sizeOption = $sizeStep.find(".main-product__size-option").first();
      const removeButtonMarkup = `
        <button type="button" class="logo-mat-wizard__size-row-remove" aria-label="Remove size">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M9 3h6l1 2h4v2H4V5h4l1-2zm-1 6h2v9H8V9zm4 0h2v9h-2V9zm4 0h2v9h-2V9zM6 20h12l1-12H5l1 12z"></path>
          </svg>
        </button>
      `;

      let $sizeRows = $sizeOption.children(".logo-mat-wizard__size-rows").first();
      if ($sizeRows.length === 0) {
        $sizeRows = $('<div class="logo-mat-wizard__size-rows"></div>');
        const $initialSelect = $sizeOption
          .children(".cw-product-bundle__variant-select")
          .first()
          .addBack()
          .filter(".cw-product-bundle__variant-select")
          .first();

        if ($initialSelect.length > 0) {
          const $firstRow = $('<div class="logo-mat-wizard__size-row"></div>');
          $firstRow.append($initialSelect);
          $firstRow.append($(removeButtonMarkup));
          $sizeRows.append($firstRow);
        }
        $sizeOption.prepend($sizeRows);
      } else {
        $sizeRows.children(".logo-mat-wizard__size-row").each(function () {
          if ($(this).find(".logo-mat-wizard__size-row-remove").length === 0) {
            $(this).append($(removeButtonMarkup));
          }
        });
      }

      logoWizardState.$sizeRowsContainer = $sizeRows;

      let $sizeActions = $sizeOption.children(".logo-mat-wizard__size-actions").first();
      if ($sizeActions.length === 0) {
        $sizeActions = $(`
          <div class="logo-mat-wizard__size-actions">
            <button type="button" class="logo-mat-wizard__size-add-button" data-action="add-size">
              <span class="logo-mat-wizard__size-add-icon" aria-hidden="true">+</span>
              <span class="logo-mat-wizard__size-add-label">Add Another Size?</span>
            </button>
          </div>
        `);
        $sizeRows.after($sizeActions);
      }

      logoWizardState.$sizeAddButton = $sizeActions.find(".logo-mat-wizard__size-add-button");

      logoWizardState.$sizeAddButton.on("click", function () {
        const $templateSelect = logoWizardState.$sizeRowsContainer
          .find(".logo-mat-wizard__size-row .cw-product-bundle__variant-select")
          .first();
        if ($templateSelect.length === 0) {
          return;
        }

        const $newSelect = $templateSelect.clone();
        /* The custom width/length panel was moved under the custom hero (see
           decorateSizeOptionsForWizard), so it now lives inside the template
           select. Strip it from the clone — there must be exactly one global
           `.custom-width-input-field` (custom size is primary-row only). */
        $newSelect.find(".custom-width-input-field").remove();
        resetSizeSelectToPlaceholder($newSelect);
        const $newRow = $('<div class="logo-mat-wizard__size-row"></div>');
        $newRow.append($newSelect);
        $newRow.append($(removeButtonMarkup));
        logoWizardState.$sizeRowsContainer.append($newRow);
        refreshSizeRowsState();
      });

      $sizeOption.on("click", ".logo-mat-wizard__size-row-remove", function () {
        const $sizeRow = $(this).closest(".logo-mat-wizard__size-row");
        const $allRows = logoWizardState.$sizeRowsContainer.children(".logo-mat-wizard__size-row");
        if ($allRows.length <= 1) {
          resetSizeSelectToPlaceholder($sizeRow.find(".cw-product-bundle__variant-select").first());
        } else {
          $sizeRow.remove();
        }
        refreshSizeRowsState();
        showWizardStep(logoWizardState.currentStepIndex, { skipValidation: true });
      });

      refreshSizeRowsState();
    }

    logoWizardState.$customiseSelection
      .find(".main-product__checkout")
      .addClass("logo-mat-wizard__legacy-cta");

    /* ---------------------------------------------------------------------
       Journey-card header band (03-Jul-2026 re-skin). A single green
       gradient band at the top of the wizard card carrying an eyebrow
       ("Free Design Tool · Step N of N"), the ACTIVE step's title +
       subheading (mirrored from the step in showWizardStep so per-step
       section settings stay authoritative), and the segmented stepper.
       Replaces the old loose step-counter pill + intro heading + thin
       progress bar (both hidden via CSS). $progressCurrent/$progressTotal/
       $progressBarFill/$progressDots still point at live nodes so the
       rest of the wizard code is unchanged. */
    const $wizardBand = $(`
      <div class="logo-mat-wizard__band">
        <div class="logo-mat-wizard__eyebrow">
          <span class="logo-mat-wizard__eyebrow-label">Free Design Tool</span>
          <span class="logo-mat-wizard__eyebrow-step" aria-live="polite">Step <strong class="logo-mat-wizard__progress-current">1</strong> of <strong class="logo-mat-wizard__progress-total">1</strong></span>
        </div>
        <h2 class="logo-mat-wizard__band-title"></h2>
        <p class="logo-mat-wizard__band-sub"></p>
        <div class="logo-mat-wizard__progress-bar" aria-hidden="true">
          <span class="logo-mat-wizard__progress-bar-fill"></span>
          <div class="logo-mat-wizard__progress-dots"></div>
        </div>
      </div>
    `);
    logoWizardState.$customiseSelection.prepend($wizardBand);

    logoWizardState.$progressCurrent = $wizardBand.find(".logo-mat-wizard__progress-current");
    logoWizardState.$progressTotal = $wizardBand.find(".logo-mat-wizard__progress-total");
    logoWizardState.$progressBarFill = $wizardBand.find(".logo-mat-wizard__progress-bar-fill");
    logoWizardState.$progressDots = $wizardBand.find(".logo-mat-wizard__progress-dots");
    logoWizardState.$bandTitle = $wizardBand.find(".logo-mat-wizard__band-title");
    logoWizardState.$bandSub = $wizardBand.find(".logo-mat-wizard__band-sub");

    const detailsHeading =
      safeTrim(
        logoWizardState.$customiseSelection.attr("data-wizard-details-heading")
      ) || "Where shall we send your free design?";
    /* Empty subheading → no subheading rendered (the conditional below
       skips the <p> when this is blank). Hardcoded fallback removed
       03-Jun-2026 — the contact step now leads with just the
       "Where shall we send your free design?" headline, which tested
       better at reducing drop-off than the prior two-line treatment. */
    const detailsSubheading = safeTrim(
      logoWizardState.$customiseSelection.attr("data-wizard-details-subheading")
    );
    const detailsTooltip = safeTrim(
      logoWizardState.$customiseSelection.attr("data-wizard-details-tooltip")
    );
    const detailsTooltipMarkup = detailsTooltip
      ? `<button type="button" class="logo-mat-wizard__heading-tooltip" title="${escapeHtml(
          detailsTooltip
        )}" aria-label="${escapeHtml(detailsTooltip)}">?</button>`
      : "";
    const detailsSubheadingMarkup = detailsSubheading
      ? `<p class="logo-mat-wizard__step-subheading">${escapeHtml(detailsSubheading)}</p>`
      : "";

    const $detailsStep = $(`
      <div class="main-product__customise-wrapper logo-mat-wizard__details-step logo-mat-wizard__step">
        <div class="main-product__customise-block">
          <div class="main-product__select-heading">
            <span class="main-product__select-count"></span>
            <div class="logo-mat-wizard__heading-row">
              <span class="main-product__select-text">${escapeHtml(detailsHeading)}</span>
              ${detailsTooltipMarkup}
            </div>
            ${detailsSubheadingMarkup}
          </div>
          <div class="main-product__select-block">
            <div class="logo-mat-wizard__checkout-slot"></div>
          </div>
        </div>
      </div>
    `);

    logoWizardState.$customiseSelection.append($detailsStep);
    logoWizardState.$reviewStep = $();
    logoWizardState.$detailsStep = $detailsStep;
    logoWizardState.$summaryList = $();
    logoWizardState.$summaryHelpText = $();
    logoWizardState.$continueDetailsButton = $();
    /* Help block is now appended ONCE to the wizard container after
       the navigation (see further down). The previous per-step
       `appendWizardNeedHelp($detailsStep)` call has been removed —
       leaving it in place threw a ReferenceError that killed wizard
       initialisation and made the form render as one long page.
       (03-Jun-2026.) */

    $checkout
      .appendTo($detailsStep.find(".logo-mat-wizard__checkout-slot"))
      .addClass("logo-mat-wizard__inline-checkout")
      .show();

    const $wizardCheckoutForm = $detailsStep.find(".secure-checkout__form").first();
    if ($wizardCheckoutForm.length > 0) {
      $wizardCheckoutForm
        .find(".secure-checkout__title")
        .text(detailsHeading || "Enter Details");
      $wizardCheckoutForm
        .find(".secure-checkout__information p")
        .text(detailsSubheading || "Enter your contact details so we can send you over your proof");

      const $wizardFillData = $wizardCheckoutForm.find(".secure-checkout__fill-data").first();
      const $firstNameField = $wizardCheckoutForm.find("#firstName").closest(".secure-checkout__field");
      const $surnameField = $wizardCheckoutForm.find("#surname").closest(".secure-checkout__field");
      const $emailField = $wizardCheckoutForm.find("#email").closest(".secure-checkout__field");
      const $companyField = $wizardCheckoutForm.find("#company").closest(".secure-checkout__field");
      const $phoneField = $wizardCheckoutForm.find("#phone").closest(".secure-checkout__field");

      if ($wizardFillData.length > 0) {
        $wizardFillData.append($firstNameField, $surnameField, $emailField, $companyField, $phoneField);
      }

      $firstNameField.find(".secure-checkout__label").text("First Name");
      $surnameField.find(".secure-checkout__label").text("Last Name");
      $wizardCheckoutForm.find('label[for="company"], #company').closest(".secure-checkout__field").find(".secure-checkout__label").text("Company");
      $wizardCheckoutForm.find("#firstName").attr("placeholder", "Enter First Name");
      $wizardCheckoutForm.find("#surname").attr("placeholder", "Enter Last Name");
      $wizardCheckoutForm.find("#email").attr("placeholder", "Enter your email");
      $wizardCheckoutForm.find("#company").attr("placeholder", "Enter Company Name");
      $wizardCheckoutForm.find("#phone").attr("placeholder", "Enter Contact Number");
      $wizardCheckoutForm.find(".secure-checkout__button").text("Generate Logo Mat Proof");
    }

    const $wizardNav = $(`
      <div class="logo-mat-wizard__navigation">
        <button type="button" class="logo-mat-wizard__nav-button logo-mat-wizard__nav-button--back">Back</button>
        <button type="button" class="logo-mat-wizard__nav-button logo-mat-wizard__nav-button--next">Next</button>
      </div>
    `);
    logoWizardState.$customiseSelection.append($wizardNav);
    /* Need-help block now lives BELOW the navigation (was previously
       appended inside each step's `.main-product__customise-block`).
       Since the nav is shared across all steps, one append here means
       a single rendered help block sits at the bottom of the wizard on
       every step — no per-step duplication. (03-Jun-2026.) */
    if (wizardHelpMarkup) {
      logoWizardState.$customiseSelection.append(wizardHelpMarkup);
    }
    logoWizardState.$backButton = $wizardNav.find(".logo-mat-wizard__nav-button--back");
    logoWizardState.$nextButton = $wizardNav.find(".logo-mat-wizard__nav-button--next");

    logoWizardState.$nextButton.on("click", function () {
      showWizardStep(logoWizardState.currentStepIndex + 1);
    });

    logoWizardState.$backButton.on("click", function () {
      if (logoWizardState.isSubmissionComplete) {
        resetWizardForNewSubmission();
        return;
      }
      showWizardStep(logoWizardState.currentStepIndex - 1, { skipValidation: true });
    });

    /* Dull the "Generate Logo Mat Proof" button until the required contact
       fields are completed (03-Jul-2026). Uses a CLASS, not the disabled
       prop, so it doesn't collide with the submit-in-progress state, and a
       click while incomplete still runs the existing per-field validation
       (which tells the user exactly what's missing). The check is deliberately
       a touch looser than the submit validator (basic email pattern, phone
       non-empty) so it never blocks a genuinely valid submission. */
    function updateGenerateButtonState() {
      var $btn = $(".secure-checkout__form .secure-checkout__button");
      if (!$btn.length) return;
      var firstName = safeTrim($("#firstName").val());
      var surname = safeTrim($("#surname").val());
      var company = safeTrim($("#company").val());
      var email = safeTrim($("#email").val());
      var phone = safeTrim($("#phone").val());
      var emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
      var complete = !!(firstName && surname && company && emailOk && phone);
      $btn.toggleClass("logo-mat-wizard__gen-incomplete", !complete);
    }
    $(document).on(
      "input change",
      "#firstName, #surname, #company, #email, #phone",
      updateGenerateButtonState
    );
    updateGenerateButtonState();

    $(document).on(
      "change",
      'input[name="bespoke-option"], input[name="background-color-swatch"], input[name="select-orientation"], input[name="select-backing"], input[name="width"], input[name="length"], #color-option-input, #backgroundCustomColourInput, #backgroundCustomColourHex',
      function () {
        if (logoWizardState.enabled) {
          showWizardStep(logoWizardState.currentStepIndex, { skipValidation: true });
        }
      }
    );

    $(document).on(
      "click",
      ".main-product__size-option .cw-product-bundle__variant-option, .main-product__quantity-option .cw-product-bundle__variant-option",
      function () {
        if (logoWizardState.enabled) {
          showWizardStep(logoWizardState.currentStepIndex, { skipValidation: true });
        }
      }
    );

    /* Defensive open for the "Enquire by Email" button in the wizard's
     Need Help block (03-Jun-2026). The anchor's default `mailto:`
     activation was being suppressed somewhere — couldn't find a clear
     culprit, but the symptom was: clicking the button did nothing.
     Programmatically setting `window.location` ignores any prior
     `event.preventDefault()` from upstream delegated handlers and forces
     the browser to open the user's mail handler.

     `closest()` ensures clicks that land on the inner SVG/<span> still
     resolve to the anchor. We don't call preventDefault here — letting
     the native handling fire too is harmless (the second navigation
     attempt is a no-op once the first opens the mail app). */
  $(document).on("click", ".logo-mat-wizard__need-help-btn--email", function (e) {
    const href = (this.getAttribute && this.getAttribute("href")) || "";
    if (href.indexOf("mailto:") === 0) {
      try {
        window.location.href = href;
      } catch (err) {
        /* swallow — native default will still fire */
      }
    }
  });

  $(document).on("click", ".logo-mat-wizard__size-help-toggle", function () {
      const $toggle = $(this);
      const targetId = safeTrim($toggle.attr("aria-controls"));
      if (!targetId) {
        return;
      }
      const $panel = $(`#${targetId}`);
      if ($panel.length === 0) {
        return;
      }
      const isExpanded = $toggle.attr("aria-expanded") === "true";
      $toggle.attr("aria-expanded", isExpanded ? "false" : "true");
      $panel.prop("hidden", isExpanded);
    });

    /* Intro / "start" screen (03-Jul-2026): a pre-step green panel that gives
       users a clear starting action. If present (`[data-lmw-intro]`), the
       wizard opens on it (class `is-intro` hides the band/steps/nav/help via
       CSS); clicking "Start my free design" reveals step 1. Not counted as a
       wizard step — $designSteps only picks up `.main-product__customise-wrapper`. */
    const $introScreen = logoWizardState.$customiseSelection.find("[data-lmw-intro]").first();
    if ($introScreen.length > 0) {
      logoWizardState.$customiseSelection.addClass("is-intro");

      /* Pop-out / modal wizard (10-Jul-2026): the intro panel stays inline on
         the product page; clicking "Start" lifts the SAME wizard card into a
         centred modal (backdrop + scroll-lock) for more space + focus. Closing
         (×, backdrop, or Esc) returns it to the inline intro teaser. The form
         markup/flow is unchanged — this only repositions the card. */
      const $card = logoWizardState.$customiseSelection;
      const $body = $("body");
      let $backdrop = null;
      let lastFocusedEl = null;

      function closeWizardModal() {
        $card.removeClass("is-lmw-modal").removeAttr("role").removeAttr("aria-modal");
        $body.removeClass("lmw-modal-open");
        if ($backdrop) {
          $backdrop.remove();
          $backdrop = null;
        }
        $(document).off("keydown.lmwModal");
        $card.addClass("is-intro");
        showWizardStep(0, { skipValidation: true });
        if (lastFocusedEl && typeof lastFocusedEl.focus === "function") {
          try { lastFocusedEl.focus(); } catch (e) {}
        }
      }

      function openWizardModal() {
        lastFocusedEl = document.activeElement;
        $backdrop = $('<div class="lmw-modal-backdrop"></div>')
          .appendTo($body)
          .on("click", closeWizardModal);
        $body.addClass("lmw-modal-open");
        $card
          .removeClass("is-intro")
          .addClass("is-lmw-modal")
          .attr({ role: "dialog", "aria-modal": "true" });
        if ($card.find(".lmw-modal-close").length === 0) {
          $(
            '<button type="button" class="lmw-modal-close" aria-label="Close design tool">&times;</button>'
          )
            .appendTo($card)
            .on("click", closeWizardModal);
        }
        $(document).on("keydown.lmwModal", function (e) {
          if (e.key === "Escape" || e.keyCode === 27) closeWizardModal();
        });
        showWizardStep(0, { skipValidation: true });
        $card.scrollTop(0);
      }

      logoWizardState.closeWizardModal = closeWizardModal;

      $introScreen.on("click", "[data-lmw-intro-start]", function (e) {
        e.preventDefault();
        openWizardModal();
      });
    }

    showWizardStep(0, { skipValidation: true });
  }




  // New js start here 28-04-25
  let productCusNavSlider = $(".js-product-cus-nav-slider");
  let productCusThumbSlider = $(".js-product-cus-thumb-slider");

  if (
    productCusNavSlider.length > 0 &&
    !productCusNavSlider.hasClass("slick-initialized") &&
    productCusThumbSlider.length > 0 &&
    !productCusThumbSlider.hasClass("slick-initialized")
  ) {
    productCusNavSlider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      fade: false,
      infinite: true,
      speed: 500,
      asNavFor: ".js-product-cus-thumb-slider", // corrected selector
    });

    productCusThumbSlider.slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      asNavFor: ".js-product-cus-nav-slider", // corrected selector
      arrows: true,
      dots: false,
      infinite: true,
      centerMode: false,
      focusOnSelect: true,
      variableWidth: false,
      prevArrow:
        '<button type="button" class="prev-arrow" aria-label="Previous slide">' +
        '<svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M7 1L1 7L7 13" stroke="#222329" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
        "</svg>" +
        "</button>",
      nextArrow:
        '<button type="button" class="next-arrow" aria-label="Next slide">' +
        '<svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M1 13L7 7L1 1" stroke="#222329" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
        "</svg>" +
        "</button>",
    });
  }
  // New js start here 28-04-25

  $(".main-product__quantity-option")
    .find(".cw-product-bundle__variant-option")
    .first()
    .addClass("active-status");

  $(".cw-product-bundle__variant-select").each(function (
    index,
    currentSelecter
  ) {
    // console.log("currentSelecter ", currentSelecter);

    // Skip auto-selection for the size dropdown — show "Select Size" placeholder instead
    var isSizeDropdown = $(this).closest(".main-product__size-option").length > 0;

    let minPriceOption = null;
    let minPrice = Infinity;
    let firstSelectedQty;

    $(this)
      .find(".cw-product-bundle__variant-option")
      .each(function (i, optiondata) {
        // console.log("optiondata ", optiondata);
        let optionQty = $(optiondata).attr("data-selected-qty");
        if (optionQty && i == 0) {
          firstSelectedQty = optionQty;
          // console.log("firstSelectedQty ", firstSelectedQty);

          $(
            ".main-product__quantity-option .cw-product-bundle__variant-selected"
          ).attr("currentQty", optionQty);
        }
        const price = parseFloat($(this).data("variant-price") / 100) || 0;

        // Check if price is 59 or above and is the lowest found so far
        if (price >= 59 && price < minPrice) {
          // console.log("price", price);
          minPrice = price;
          minPriceOption = $(this);
        }

        if (
          $(optiondata).attr("data-text").toUpperCase().indexOf("CUSTOM") > -1
        ) {
          /* Don't hide the price slot if it's already been decorated with
             the "Choose →" CTA pill (see decorateSizeOptionsForWizard
             ~L2128) — that decoration repurposes the slot rather than
             leaving it empty, and hiding it would erase the only
             interactive cue on the custom-size row. */
          const $customPriceEl = $(optiondata).find(".cw-product-bundle__option-price");
          if (!$customPriceEl.hasClass("cw-product-bundle__option-price--custom-cta")) {
            $customPriceEl.hide();
          }
        }
      });

    if (minPriceOption && !isSizeDropdown) {
      // console.log("check minprice");
      const selectedText = minPriceOption.data("text") || "";
      const selectedSavePercentage =
        minPriceOption.data("save-percentage") || "";
      const selectedPrice = minPriceOption.data("price") || "";
      const selectedVariantPrice = minPriceOption.data("variant-price") || "";
      const selectedValue = minPriceOption.text() || "";

      if (firstSelectedQty) {
        // console.log("optiondata qty ", optionQty);
      }

      // Generate HTML for the selected option display
      const selectedHtml = `
                ${
                  selectedText
                    ? `<span class="cw-product-bundle__variant-text" data-variant-price="${selectedVariantPrice}">${selectedText}</span>`
                    : ""
                }
                ${
                  selectedSavePercentage
                    ? `<span class="cw-product-bundle__variant-save-percentage ssss">${selectedSavePercentage}</span>`
                    : ""
                }
                ${
                  selectedPrice
                    ? `<span class="cw-product-bundle__variant-price demo123">${selectedPrice}</span>`
                    : ""
                }
            `;

      // Update the DOM elements with the selected option's details
      $(this).find(".cw-product-bundle__variant-selected").html(selectedHtml);
      $(this).find('input[type="hidden"]').val(selectedValue);

      // console.log("Selected option:", {
      //     text: selectedText,
      //     savePercentage: selectedSavePercentage,
      //     price: selectedPrice,
      //     variantPrice: selectedVariantPrice
      // });
      OptionsHandler(minPriceOption);
    } else {
      // console.log("No option with a price of 59 or higher found.");
    }
  });

  function decorateSizeOptionsForWizard() {
    $(".main-product__size-option .cw-product-bundle__variant-option").each(function () {
      const $option = $(this);
      const optionText = String(
        $option.attr("data-text") ||
          $option.find(".cw-product-bundle__option-text").text() ||
          ""
      );
      const optionTextLower = optionText.toLowerCase();

      if (optionTextLower.indexOf("custom") > -1) {
        $option.addClass("cw-product-bundle__variant-option--custom-size");
        /* Replace the empty hidden price slot with a "Choose →" CTA pill
           so the row reads as a clear interactive choice rather than a
           passive footer banner. The pill sits in the same grid-area
           ("price") that displays £XX.XX on standard rows, so the row's
           visual rhythm matches the rest of the dropdown. CSS:
           `.cw-product-bundle__option-price--custom-cta` (see
           eq-product-style.css). */
        const $priceSlot = $option
          .find(".cw-product-bundle__option-price")
          .first();
        if ($priceSlot.length && $priceSlot.find(".cw-product-bundle__custom-cta").length === 0) {
          $priceSlot
            .addClass("cw-product-bundle__option-price--custom-cta")
            .show()
            .html(
              '<span class="cw-product-bundle__custom-cta">' +
              '<span class="cw-product-bundle__custom-cta-text">Enter size</span>' +
              '<span class="cw-product-bundle__custom-cta-arrow" aria-hidden="true">▾</span>' +
              '</span>'
            );
        }
      }

    });

    $(".main-product__size-option .cw-product-bundle__variant-options").each(function () {
      const $list = $(this);

      /* Journey-card INLINE size list (03-Jul-2026): the CSS neutralises the
         dropdown popover so this list renders inline (always open) with the
         trigger hidden. Custom hero FIRST, a divider before the standard
         sizes, and non-popular "extra" sizes collapsed behind an expander.
         Presentational only — tiles keep their data-* contract + click-to-
         select handler. */
      const $customSizeOption = $list
        .children(".cw-product-bundle__variant-option--custom-size")
        .first();
      if ($customSizeOption.length) {
        $customSizeOption.prependTo($list);

        /* Build the custom hero's inner structure once: icon square + a
           title-row (label + "Most requested" pill) + subtitle + a selected
           check. The pill/subtitle are SIBLINGS of the label, not inside it,
           so updateCustomSizeLabels()'s .text() on the label can't wipe them. */
        if (!$customSizeOption.hasClass("lmw-custom-hero-built")) {
          $customSizeOption.addClass("lmw-custom-hero-built");
          const $heroLabel = $customSizeOption
            .find(".cw-product-bundle__option-text")
            .first();
          $heroLabel.before(
            '<span class="cw-product-bundle__custom-icon" aria-hidden="true">' +
              '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="#E9B23C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 8V5a2 2 0 0 1 2-2h3M16 3h3a2 2 0 0 1 2 2v3M21 16v3a2 2 0 0 1-2 2h-3M8 21H5a2 2 0 0 1-2-2v-3"/><path d="M9 9h6v6H9z"/></svg>' +
            "</span>"
          );
          $heroLabel.wrap('<span class="cw-product-bundle__custom-titlerow"></span>');
          $heroLabel.after(
            '<span class="cw-product-bundle__custom-badge">★ Most requested</span>'
          );
          $customSizeOption
            .find(".cw-product-bundle__custom-titlerow")
            .after(
              '<span class="cw-product-bundle__custom-sub">Made to your exact measurements — our most popular choice.</span>'
            );
          $customSizeOption.append(
            '<span class="cw-product-bundle__custom-check" aria-hidden="true">' +
              '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="#ffffff" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>' +
            "</span>"
          );
        }

        if ($list.children(".cw-product-bundle__size-divider").length === 0) {
          $customSizeOption.after(
            '<div class="cw-product-bundle__size-divider"><span>Or pick a standard size</span></div>'
          );
        }

        /* Move the width/length panel to sit directly under the custom hero
           (by default it lives at wrapper level, appearing below every size).
           Inserted BEFORE the divider → hero, inputs, divider, standard sizes.
           It's a single global element (custom is primary-size only); the
           "Add another size" clone strips any copy of it (see add handler). */
        const $sizeInputs = $customSizeOption
          .closest(".main-product__customise-wrapper")
          .find(".custom-width-input-field")
          .first();
        if ($sizeInputs.length) {
          $customSizeOption.after($sizeInputs);
        }
      }

      /* Collapse extras behind an expander. SAFE DEFAULT: extras hide ONLY
         while the list carries `is-collapsed`, so a JS failure leaves every
         size visible + selectable. Delegated handler (below) covers cloned
         "Add another size" rows. */
      const $extras = $list.children(".cw-product-bundle__variant-option--extra");
      if (
        $extras.length > 0 &&
        $list.children(".cw-product-bundle__size-expander").length === 0
      ) {
        $list.addClass("is-collapsed");
        $list.append(
          '<button type="button" class="cw-product-bundle__size-expander" aria-expanded="false">' +
            '<span class="cw-product-bundle__size-expander-sign" aria-hidden="true">+</span>' +
            '<span class="cw-product-bundle__size-expander-label">Show smaller &amp; larger sizes</span>' +
          "</button>"
        );
      }
    });

    updateCustomSizeLabels();
  }

  /* Expander toggle for the collapsed "extra" sizes. Delegated on document so
     it covers size selectors cloned by "Add another size"; stopPropagation so
     the click never reaches the size selection/close handlers. */
  $(document).on("click", ".cw-product-bundle__size-expander", function (e) {
    e.preventDefault();
    e.stopPropagation();
    const $btn = $(this);
    const $list = $btn.closest(".cw-product-bundle__variant-options");
    const isCollapsed = $list.toggleClass("is-collapsed").hasClass("is-collapsed");
    $btn.attr("aria-expanded", isCollapsed ? "false" : "true");
    $btn.find(".cw-product-bundle__size-expander-sign").text(isCollapsed ? "+" : "–");
    $btn
      .find(".cw-product-bundle__size-expander-label")
      .text(isCollapsed ? "Show smaller & larger sizes" : "Hide extra sizes");
  });

  /* Live "calculated size" readout in the custom-size panel (03-Jul-2026):
     echoes the entered W × L in the bottom-right of the "Enter your size"
     container as the user types. Hidden until both dimensions are present.

     Inline price cell added 15-Jul-2026: `customPriceHandler`'s
     calculatePrice is bound DIRECTLY on these inputs, so it has already
     run (and stamped fresh ex/inc prices on `.main-product__price-value`)
     before this delegated handler fires. We echo those values into the
     `[data-lmw-custom-price]` cell that sits to the right of the W/L
     inputs — mirroring the "size .... price" layout of the standard size
     rows. data-ex/inc-price + fm-vat-label keep it VAT-mode aware
     (fm-vat.js swaps them). Hidden until a price has been computed. */
  $(document).on("input", 'input[name="width"], input[name="length"]', function () {
    const $calc = $("[data-lmw-custom-calc]");
    const $priceCell = $("[data-lmw-custom-price]");
    const widthVal = parseFloat($('input[name="width"]').val());
    const lengthVal = parseFloat($('input[name="length"]').val());
    const bothEntered = widthVal > 0 && lengthVal > 0;

    if ($calc.length) {
      if (bothEntered) {
        $calc.text(`Your size: ${widthVal}cm × ${lengthVal}cm`).prop("hidden", false);
      } else {
        $calc.text("").prop("hidden", true);
      }
    }

    if ($priceCell.length) {
      const $priceSrc = $(".main-product__price-value").first();
      const exPrice = $priceSrc.attr("data-ex-price");
      const incPrice = $priceSrc.attr("data-inc-price");
      if (bothEntered && exPrice && incPrice) {
        const isInc = window.fmVatMode === "inc";
        $priceCell
          .find("[data-lmw-custom-price-value]")
          .attr("data-ex-price", exPrice)
          .attr("data-inc-price", incPrice)
          .text(isInc ? incPrice : exPrice);
        $priceCell.prop("hidden", false);
      } else {
        $priceCell.prop("hidden", true);
      }
    }
  });

  decorateSizeOptionsForWizard();

  // Stop the mouse wheel from changing the custom size number inputs while
  // they're focused (default <input type=number> behaviour — easy to nudge
  // width/length by accident when scrolling the page). Scoped to the custom
  // size fields only; page scrolling is unaffected when they aren't focused.
  document.addEventListener(
    "wheel",
    function (e) {
      var el = e.target;
      if (
        el &&
        el.tagName === "INPUT" &&
        el.type === "number" &&
        document.activeElement === el &&
        (el.name === "width" ||
          el.name === "length" ||
          el.classList.contains("custom-width__value") ||
          el.classList.contains("custom-length__value"))
      ) {
        e.preventDefault();
      }
    },
    { passive: false }
  );

  function OptionsHandler(ele) {
    // console.log("main ele", ele, $(ele).html());
    let selectedText = $(ele).attr("data-text") || "";
    let displaySelectedText = selectedText;
    
    let selectedVariantID = Number($(ele).attr("data-variant-id"));

    if ($(".main-product__checkout-button").length > 0) {
      $(".main-product__checkout-button").attr(
        "data-variant-id",
        selectedVariantID
      );
    }

    let selectedSavePercentage = $(ele).attr("data-save-percentage") || "";
    // VAT-toggle aware (08-Jun-2026): each size option carries both the
    // ex (`data-price`) and inc (`data-price-inc`) money strings. Pick
    // the one matching the current display mode, but keep BOTH so the
    // display elements can be re-swapped if the user toggles afterward.
    let fmIncMode = (window.fmVatMode === "inc");
    let selectedPrice_ex  = $(ele).attr("data-price") || "";
    let selectedPrice_inc = $(ele).attr("data-price-inc") || selectedPrice_ex;
    let selectedPrice_02  = fmIncMode ? selectedPrice_inc : selectedPrice_ex;

    let dataWithoutMoneyPrice = $(ele).attr("data-without-monny-formate") || "";
    let selectedValue = $(ele).text();
    const isSizeDropdownOption =
      $(ele).closest(".main-product__size-option").length > 0;
    console.log('dataWithoutMoneyPrice ' + dataWithoutMoneyPrice);
    //let qtyDropText = $(".main-product__quantity-option").find(".cw-product-bundle__variant-option").first().data('text');
    let qtyDropText = $(".main-product__quantity-option")
      .find(".cw-product-bundle__variant-option.active-status")
      .data("text");

    // set first option text in qty selector
    $(".main-product__quantity-option")
      .find(
        ".cw-product-bundle__variant-selected .cw-product-bundle__variant-text"
      )
      .text(qtyDropText);

    // set main price — write to the dedicated `.main-product__price-value`
    // span (the redesigned hero price block has 3 sibling spans:
    // label, value, vat-suffix). The old selector `.main-product__price span`
    // hit all three, replacing label + suffix with the price value.
    // Write the mode-appropriate price + refresh BOTH data attributes so
    // a later VAT toggle re-swaps correctly. The vat-suffix label
    // (.main-product__price-vat / .fm-vat-label) is handled by fm-vat.js.
    $(".main-product__price-value")
      .attr("data-ex-price", selectedPrice_ex)
      .attr("data-inc-price", selectedPrice_inc)
      .text(selectedPrice_02);

    let selectedHtml = "";

    if (isSizeDropdownOption && isCustomOptionElement($(ele))) {
      displaySelectedText = getCustomSizeDisplayText();
    }

    if (displaySelectedText) {
      selectedHtml += `<span class="cw-product-bundle__variant-text">${displaySelectedText}</span>`;
    }
    if (selectedSavePercentage) {
      selectedHtml += `<span class="cw-product-bundle__variant-save-percentage ddddd">${selectedSavePercentage}</span>`;
    }
    if (selectedPrice_02) {
      selectedHtml += `<span class="cw-product-bundle__variant-price" data-ex-price="${selectedPrice_ex}" data-inc-price="${selectedPrice_inc}" data-without-money-total="${dataWithoutMoneyPrice}" data-total-price="${selectedPrice_02}">${selectedPrice_02}</span>`;
    }

    if (isSizeDropdownOption && isCustomOptionElement($(ele))) {
      selectedValue = displaySelectedText;
    }

    $(ele)
      .closest(".cw-product-bundle__variant-select")
      .find(".cw-product-bundle__variant-selected")
      .html(selectedHtml);
    $(ele)
      .closest(".cw-product-bundle__variant-select")
      .find('input[type="hidden"]')
      .val(selectedValue);

    if (isSizeDropdownOption) {
      const $sizeVariantSelect = $(ele).closest(".cw-product-bundle__variant-select");
      const isCustomSizeOptionSelected = isCustomOptionElement($(ele));
      $(ele)
        .closest(".cw-product-bundle__variant-options")
        .find(".cw-product-bundle__variant-option")
        .removeClass("active-status");
      $(ele).addClass("active-status");
      $sizeVariantSelect.attr(
        "data-selected-variant-id",
        safeTrim($(ele).attr("data-variant-id"))
      );
      $sizeVariantSelect.attr("data-selected-option-text", safeTrim(displaySelectedText));
      $sizeVariantSelect.attr("data-selected-option-raw-text", safeTrim(selectedText));
      $sizeVariantSelect.attr(
        "data-selected-is-custom-size",
        isCustomSizeOptionSelected ? "true" : "false"
      );
      $sizeVariantSelect.toggleClass(
        "is-custom-size-selected",
        isCustomSizeOptionSelected
      );
      $sizeVariantSelect.removeClass("is-open");
      $sizeVariantSelect.find(".cw-product-bundle__variant-options").hide();
      updateCustomSizeLabels();
    } else {
      $(ele).parent().hide();
    }

    let selected_variant_option_price = parseFloat(
      $(ele).attr("data-variant-price")
    );
    if (
      !isNaN(selected_variant_option_price) &&
      selected_variant_option_price > 0
    ) {
      //   const tenPercent = (selected_variant_option_price * 1 / 100);
      const tenPercent_1 = selected_variant_option_price;

      const fifteenPercentage = $(
        '.cw-product-bundle__variant-option[data-selected-qty="2"]'
      ).attr("data-save-percentage");
      const fifteenPercentFormate = fifteenPercentage.replace("%", "");
      const fifteenPercent =
        (selected_variant_option_price * fifteenPercentFormate) / 100;
      const fifteenPercent_1 = selected_variant_option_price - fifteenPercent;

      const twentyPercentage = $(
        '.cw-product-bundle__variant-option[data-selected-qty="3"]'
      ).attr("data-save-percentage");
      const twentyPercentFormate = twentyPercentage.replace("%", "");
      const twentyPercent =
        (selected_variant_option_price * twentyPercentFormate) / 100;
      const twentyPercent_1 = selected_variant_option_price - twentyPercent;

      const thirtyPercentage = $(
        '.cw-product-bundle__variant-option[data-selected-qty="4"]'
      ).attr("data-save-percentage");
      const thirtyPercentFormate = thirtyPercentage.replace("%", "");
      const thirtyPercent =
        (selected_variant_option_price * thirtyPercentFormate) / 100;
      const thirtyPercent_1 = selected_variant_option_price - thirtyPercent;

      // let percentage_off = $(".main-product__quantity-option")
      //   .find(".cw-product-bundle__variant-save-percentage")
      //   .html();
      let percentage_off = $(".main-product__quantity-option")
        .find(".cw-product-bundle__variant-save-percentage")
        .text()
        .replace("Save", "")
        .trim();

      // if (percentage_off == "20%") {
      //   $(".main-product__quantity-option")
      //     .find(".cw-product-bundle__variant-price")
      //     .html(Shopify.formatMoney(twentyPercent_1));
      // } else if (percentage_off == "15%") {
      //   $(".main-product__quantity-option")
      //     .find(".cw-product-bundle__variant-price")
      //     .html(Shopify.formatMoney(fifteenPercent_1));
      // } else {
      //   $(".main-product__quantity-option")
      //     .find(".cw-product-bundle__variant-price")
      //     .html(Shopify.formatMoney(tenPercent_1));
      // }

      // if (percentage_off == twentyPercentage) {
      //   $(".main-product__quantity-option")
      //     .find(".cw-product-bundle__variant-price")
      //     .html(Shopify.formatMoney(twentyPercent_1));
      // } else if (percentage_off == fifteenPercentage) {
      //   $(".main-product__quantity-option")
      //     .find(".cw-product-bundle__variant-price")
      //     .html(Shopify.formatMoney(fifteenPercent_1));
      // } else if (percentage_off == thirtyPercentage) {
      //   $(".main-product__quantity-option")
      //     .find(".cw-product-bundle__variant-price")
      //     .html(Shopify.formatMoney(thirtyPercent_1));
      // } else {
      //   $(".main-product__quantity-option")
      //     .find(".cw-product-bundle__variant-price")
      //     .html(Shopify.formatMoney(tenPercent_1));
      // }

      if (percentage_off == thirtyPercent_1) {
        $(".main-product__quantity-option")
          .find(".cw-product-bundle__variant-price")
          .html(Shopify.formatMoney(thirtyPercent_1));
      } else if (percentage_off == twentyPercentage) {
        $(".main-product__quantity-option")
          .find(".cw-product-bundle__variant-price")
          .html(Shopify.formatMoney(twentyPercent_1));
      } else if (percentage_off == fifteenPercentage) {
        $(".main-product__quantity-option")
          .find(".cw-product-bundle__variant-price")
          .html(Shopify.formatMoney(fifteenPercent_1));
      } else {
        $(".main-product__quantity-option")
          .find(".cw-product-bundle__variant-price")
          .html(Shopify.formatMoney(tenPercent_1));
      }

      $('.cw-product-bundle__variant-option[data-selected-qty="4"]').attr(
        "data-price",
        Shopify.formatMoney(thirtyPercent_1)
      );
      $('.cw-product-bundle__variant-option[data-selected-qty="4"]')
        .find(".cw-product-bundle__option-price")
        .html(Shopify.formatMoney(thirtyPercent_1));

      $('.cw-product-bundle__variant-option[data-selected-qty="3"]').attr(
        "data-price",
        Shopify.formatMoney(twentyPercent_1)
      );
      $('.cw-product-bundle__variant-option[data-selected-qty="3"]')
        .find(".cw-product-bundle__option-price")
        .html(Shopify.formatMoney(twentyPercent_1));

      $('.cw-product-bundle__variant-option[data-selected-qty="2"]').attr(
        "data-price",
        Shopify.formatMoney(fifteenPercent_1)
      );
      $('.cw-product-bundle__variant-option[data-selected-qty="2"]')
        .find(".cw-product-bundle__option-price")
        .html(Shopify.formatMoney(fifteenPercent_1));
      $('.cw-product-bundle__variant-option[data-selected-qty="1"]').attr(
        "data-price",
        Shopify.formatMoney(tenPercent_1)
      );
      $('.cw-product-bundle__variant-option[data-selected-qty="1"]')
        .find(".cw-product-bundle__option-price")
        .html(Shopify.formatMoney(tenPercent_1));
      // console.log("data234");

      let UpdatedSizePrice = $(
        ".main-product__select-dropdown.main-product__quantity-option"
      )
        .find(".cw-product-bundle__variant-option.active-status")
        .attr("data-price");
      $(".main-product__select-dropdown.main-product__quantity-option")
        .find(
          ".cw-product-bundle__variant-selected .cw-product-bundle__variant-price"
        )
        .text(UpdatedSizePrice);
    }

    var selected_size_dropdown = $(
      ".main-product__size-option .cw-product-bundle__variant-selected .cw-product-bundle__variant-text"
    ).text();
    // Detect the custom-size selection via the option's data-text (stable —
    // "Custom Size (Click to enter size)") rather than the visible label, which
    // the wizard now rewrites to "Need a different size?" (no "custom" in it).
    // Legacy text check kept as a fallback.
    var $primarySizeSelect = $(
      ".main-product__size-option .cw-product-bundle__variant-select"
    ).first();
    var eleDataText = String($(ele).attr("data-text") || "").toLowerCase();
    var isCustomSizeSelected =
      eleDataText.indexOf("custom") > -1 ||
      isCustomSelectionForSizeSelect($primarySizeSelect) ||
      (selected_size_dropdown &&
        selected_size_dropdown.toLowerCase().indexOf("custom") > -1);
    if (isCustomSizeSelected) {
      $(".custom-width-input-field").show();

      $(".cw-product-bundle__variant-price").hide();
      // custom code
      // console.log("custom option", $(this).html());
      customPriceHandler(this);
      $('.cw-product-bundle__variant-option[data-selected-qty="1"]')
        .show()
        .addClass("active-status")
        .trigger("click");
      $(
        '.cw-product-bundle__variant-option[data-selected-qty]:not([data-selected-qty="1"])'
      )
        .hide()
        .removeClass("active-status");
      $(".cw-product-bundle__variant-price").hide();
      updateCustomSizeLabels();
    } else {
      $(".custom-width-input-field").hide();
      $(".cw-product-bundle__variant-price").show();
      $('input[name="width"]').val("");
      $('input[name="length"]').val("");
      $('.cw-product-bundle__variant-option[data-selected-qty="1"]')
        .show()
        .addClass("active-status")
        .trigger("click");
      $(
        '.cw-product-bundle__variant-option[data-selected-qty]:not([data-selected-qty="1"])'
      )
        .show()
        .removeClass("active-status");
      updateCustomSizeLabels();
    }

    var selected_size_dropdown = $(
      ".main-product__size-option .cw-product-bundle__variant-selected .cw-product-bundle__variant-text"
    ).text();
    $(`[value="${selected_size_dropdown}"]`).prop("checked", true);
  }

  $(document).on("click", ".cw-product-bundle__variant-selected", function (event) {
    event.preventDefault();
    const $selected = $(this);
    const $currentSelect = $selected.closest(".cw-product-bundle__variant-select");
    const $currentOptions = $selected.siblings(".cw-product-bundle__variant-options");
    const isSizeDropdown = $selected.closest(".main-product__size-option").length > 0;

    if (isSizeDropdown) {
      const shouldOpen = !$currentSelect.hasClass("is-open");
      $(".main-product__size-option .cw-product-bundle__variant-select")
        .not($currentSelect)
        .removeClass("is-open")
        .find(".cw-product-bundle__variant-options")
        .hide();

      $(".cw-product-bundle__variant-options").not($currentOptions).hide();

      if (shouldOpen) {
        $currentSelect.addClass("is-open");
        $currentOptions.show();
      } else {
        $currentSelect.removeClass("is-open");
        $currentOptions.hide();
      }
      return;
    }

    $(".main-product__size-option .cw-product-bundle__variant-select").removeClass(
      "is-open"
    );
    $(".cw-product-bundle__variant-options").not($currentOptions).hide();
    $currentOptions.toggle();

    // custom code
    // if ($(this).find('.cw-product-bundle__variant-text').text().includes("Custom Size")) {
    //     console.log("custom");
    // } else {
    //     console.log("normal");
    // }
  });

  $(document).on(
    "click",
    ".main-product__size-option .cw-product-bundle__variant-option",
    function () {
      OptionsHandler(this);
   
    }
  );

  $('.main-product__right input[name="color-swatch"]').on(
    "change",
    function () {
      var selectedColorValue = $(
        '.main-product__right input[name="color-swatch"]:checked'
      ).val();
      $(`input[value="${selectedColorValue}"]`).prop("checked", true);
    }
  );

  $(document).on(
    "click",
    ".main-product__quantity-option .cw-product-bundle__variant-option",
    function () {
      $(
        ".main-product__quantity-option .cw-product-bundle__variant-option"
      ).removeClass("active-status");
      $(this).addClass("active-status");
     
      let selectedText = $(this).attr("data-text") || "";
      let selectedSavePercentage = $(this).attr("data-save-percentage") || "";
      let selectedPrice_03 = $(this).attr("data-price") || "";
      let selectedValue = $(this).text();
      let selectedHtml = "";
      let currentClickQty = $(this).attr("data-selected-qty");
      let fourPlusQty = $("#fourplusqty").val();
      let changeQty = $(
        ".main-product__quantity-option .cw-product-bundle__variant-selected"
      );
      if (changeQty) {
        if (selectedText == "4+ Qty") {
          $(
            ".main-product__quantity-option .cw-product-bundle__variant-selected"
          ).attr("currentqty", fourPlusQty);
        } else {
          $(
            ".main-product__quantity-option .cw-product-bundle__variant-selected"
          ).attr("currentqty", currentClickQty);
        }
        //$('.main-product__quantity-option .cw-product-bundle__variant-selected').attr('currentqty', currentClickQty);
      }

      if (selectedText) {
        selectedHtml += `<span class="cw-product-bundle__variant-text">${selectedText}</span>`;
      }
      if (selectedSavePercentage) {
        selectedHtml += `<span class="cw-product-bundle__variant-save-percentage qqqqq">Save ${selectedSavePercentage}</span>`;
      }
      if (selectedPrice_03) {
        selectedHtml += `<span class="cw-product-bundle__variant-price">${selectedPrice_03}</span>`;
      }
      $(this)
        .closest(".cw-product-bundle__variant-select")
        .find(".cw-product-bundle__variant-selected")
        .html(selectedHtml);
      $(this)
        .closest(".cw-product-bundle__variant-select")
        .find('input[type="hidden"]')
        .val(selectedValue);

      $(this).parent().hide();
      if (selectedText == "4+ Qty") {
        $(".custom-width-input-field--qty").show();
      } else {
        $(".custom-width-input-field--qty").hide();
      }
      // console.log("data456");
      document.querySelector(".main-product__price-value").textContent =
        selectedPrice_03;
    }
  );

  $(document).on("click", function (e) {
    if (!$(e.target).closest(".cw-product-bundle__variant-select").length) {
      $(".cw-product-bundle__variant-options").hide();
      $(".main-product__size-option .cw-product-bundle__variant-select").removeClass(
        "is-open"
      );
    }
  });

  // Guard added 01-Jul-2026: Fancybox is loaded by eq-plugins.js on standard
  // templates but not on the lean lm-social LP layout. Calling Fancybox.bind
  // unguarded threw a ReferenceError here, which aborted the rest of this
  // $(document).ready handler — including initLogoWizard() below — so the
  // wizard never received .is-wizard-ready and the funnel was stuck on step 1.
  if (typeof Fancybox !== "undefined") {
    Fancybox.bind("[data-fancybox]", {
      showClass: "checkout-form-popup",
    });
  }

  let trustedLogo = $(".trusted-logo__slider");

  if (trustedLogo.length > 0 && !trustedLogo.hasClass("slick-initialized")) {
    trustedLogo.slick({
      dots: false,
      arrows: false,
      slidesToShow: 5,
      infinite: true,
      lazyLoad: "progressive",
      speed: 3000,
      autoplay: true,
      autoplaySpeed: 0,
      cssEase: "linear",
      draggable: false,
      swipe: false,
      touchMove: false,
      pauseOnHover: false,
      pauseOnFocus: false,
      swipeToSlide: false,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4,
            speed: 8000,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 2,
            speed: 3000,
          },
        },
      ],
    });
  }

  if ($(".ideal-step .ideal-step__block-title").length > 0) {
    $(".ideal-step .ideal-step__block-title").matchHeight({
      byRow: true,
    });
  }

  initLogoWizard();
  updateMatwellDependentUI();
  $(document).on("change", 'input[name="select-backing"]', function () {
    updateMatwellDependentUI();
  });

  let formButton = $(".secure-checkout__form .secure-checkout__button");
  let isCheckoutSubmitting = false;
  const defaultSubmitButtonText = safeTrim(formButton.first().text()) || "Submit";
  const checkoutSubmitLoadingText = "Please Wait, Generating Design";
  let phoneNumberField = document.querySelector(
    ".secure-checkout__fill-data .secure-checkout__field input[type='tel']"
  );
  let iti;

  let phoneNumberInput = document.querySelector("#phone");
  let errorMsg = document.querySelector("#phoneError");
  let validMsg = document.querySelector("#validMsg");

  // Error messages mapped to error codes
  let errorMap = [
    "Invalid number",
    "Invalid country code",
    "Too short",
    "Too long",
    "Invalid number",
  ];

  function reset() {
    if (phoneNumberInput && errorMsg && validMsg) {
      phoneNumberInput.classList.remove("invalid");
      errorMsg.textContent = "";
      errorMsg.style.display = "none";
      validMsg.classList.add("hide");
    } else {
      console.log("Required elements not found");
    }
  }

  let showError = (msg) => {
    phoneNumberInput.classList.add("invalid");
    errorMsg.textContent = msg;
    errorMsg.style.display = "block";
  };

  function ensureCheckoutProgressUI() {
    $(".secure-checkout__form .secure-checkout__submit").each(function () {
      const $submitWrap = $(this);
      if ($submitWrap.find(".secure-checkout__progress").length > 0) {
        return;
      }

      $submitWrap.append(
        `<div class="secure-checkout__progress" role="status" aria-live="polite">
          <div class="secure-checkout__progress-track" aria-hidden="true">
            <div class="secure-checkout__progress-bar"></div>
          </div>
          <p class="secure-checkout__progress-text">${checkoutSubmitLoadingText}</p>
        </div>`
      );
    });
  }

  ensureCheckoutProgressUI();

  function setCheckoutSubmitState(isSubmitting, labelText) {
    if (formButton.length === 0) {
      return;
    }

    const $forms = formButton.closest(".secure-checkout__form");
    formButton.prop("disabled", isSubmitting);
    formButton.toggleClass("is-submitting", isSubmitting);
    $forms.toggleClass("is-submitting", isSubmitting);
    $forms
      .find(".secure-checkout__progress-text")
      .text(checkoutSubmitLoadingText);
    formButton.text(isSubmitting ? labelText || checkoutSubmitLoadingText : defaultSubmitButtonText);
  }

  function setInstantProofDebugMessage(_messageText) {
    const $debugEl = $(".secure-checkout__instant-debug");
    if ($debugEl.length === 0) {
      return;
    }
    $debugEl.text("").hide();
  }

  if ($(phoneNumberField).length > 0) {
    iti = window.intlTelInput(phoneNumberField, {
      initialCountry: "gb",
      separateDialCode: true,
      formatOnDisplay: true,
      nationalMode: false,
      utilsScript:
        "https://cdn.jsdelivr.net/npm/intl-tel-input@24.3.1/build/js/utils.js",
    });

    function resetIntlTelInput() {
      if (typeof intlTelInputUtils !== "undefined") {
        var currentText = telInput.intlTelInput(
          "getNumber",
          intlTelInputUtils.numberFormat.E164
        );
        if (typeof currentText === "string") {
          telInput.intlTelInput("setNumber", currentText); // Auto-format the number
        }
      }
    }
  }

  // Optional: Reset validation when the input is clicked or when the flag is changed
  // phoneNumberInput.addEventListener('focus', reset);

  $(formButton).click(function (e) {
    e.preventDefault();

    if (isCheckoutSubmitting) {
      return;
    }
   
    var isValid = true;
    // Clear previous error messages and invalid class
    $(".error-message").hide();
    $(".secure-checkout__form input").removeClass("invalid");

    // First Name Validation
    let firstName = $("#firstName").val();
    if (firstName && typeof firstName === "string") {
      firstName = firstName.trim();
      let firstNameValid = /^[A-Za-zÀ-ÖØ-öø-ÿ' -]+$/.test(firstName);
      if (firstNameValid) {
        $("#firstName").removeClass("invalid");
        $("#firstNameError").hide();
      } else {
        isValid = false;
        $("#firstName").addClass("invalid");
        $("#firstNameError")
          .text("First name must contain only letters.")
          .css("display", "block");
      }
    } else {
      isValid = false;
      $("#firstName").addClass("invalid");
      $("#firstNameError")
        .text("First name is required.")
        .css("display", "block");
    }

    // Surname Validation
    let surname = $("#surname").val();
    if (surname && typeof surname === "string") {
      surname = surname.trim();
      let surnameValid = /^[A-Za-zÀ-ÖØ-öø-ÿ' -]+$/.test(surname);
      if (surnameValid) {
        $("#surname").removeClass("invalid");
        $("#surnameError").hide();
      } else {
        isValid = false;
        $("#surname").addClass("invalid");
        $("#surnameError")
          .text("Surname must contain only letters.")
          .css("display", "block");
      }
    } else {
      isValid = false;
      $("#surname").addClass("invalid");
      $("#surnameError").text("Surname is required.").css("display", "block");
    }

    // Company Validation
    let company = $("#company").val();
    if (company && typeof company === "string") {
      company = company.trim();
      let companyValid = /^[A-Za-z0-9À-ÖØ-öø-ÿ&'.,\-\/() ]+$/.test(company);
      if (companyValid) {
        $("#company").removeClass("invalid");
        $("#companyError").hide();
      } else {
        isValid = false;
        $("#company").addClass("invalid");
        $("#companyError").text("Please enter a valid company name.").css("display", "block");
      }
    } else {
      isValid = false;
      $("#company").addClass("invalid");
      $("#companyError")
        .text("Company Name is required.")
        .css("display", "block");
    }

    // Email Validation
    let email = $("#email").val();
    if (email && typeof email === "string") {
      email = email.trim();
      let emailValid = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
        email
      );
      if (emailValid) {
        $("#email").removeClass("invalid");
        $("#emailError").hide();
      } else {
        isValid = false;
        $("#email").addClass("invalid");
        $("#emailError")
          .text("Please enter a valid email address.")
          .css("display", "block");
      }
    } else {
      isValid = false;
      $("#email").addClass("invalid");
      $("#emailError")
        .text("Email address is required.")
        .css("display", "block");
    }

    reset();

    let phoneNumber = phoneNumberInput.value;
    let validMsg = document.querySelector("#validMsg");
    if (!phoneNumber || phoneNumber.trim() === "") {
      showError("Phone number is required.");
      isValid = false;
    } else if (iti.isValidNumber()) {
      validMsg.classList.remove("hide");

      validMsg.textContent = "✓ Valid";
    } else {
      let errorCode = iti.getValidationError();
      let msg = errorMap[errorCode] || "Invalid number";
      showError(msg);
      isValid = false;
    }

    // If all fields are valid, submit the form
    if (isValid) {
      // Get Number with country code
      // console.log('getNumber ', iti.getNumber() );

      // Remove invalid class and hide error messages for fields that have passed validation
      $(".secure-checkout__field input").each(function () {
        let secureCheckoutInput = $(this);
        if (secureCheckoutInput.val().trim() !== "") {
          secureCheckoutInput.removeClass("invalid");
          secureCheckoutInput.siblings(".error-message").hide();
        }
      });
      // $("form").submit(); // This triggers the form submission

      const designItems = getDesignItemsForSubmission();
      const primaryDesign = designItems[0] || buildCurrentDesignItem();
      const proofMode = designItems.length > 1 ? "manual" : "instant";
      const instantProofEligible = proofMode === "instant" && designItems.length === 1;
      const requiresManualReview = !instantProofEligible;

      let customer_firstname = $("#secure-checkout").find("#firstName").val();
      let customer_surname = $("#secure-checkout").find("#surname").val();
      let customer_email = $("#secure-checkout").find("#email").val();
      let customer_phone = $("#secure-checkout").find("#phone").val();
      const customer_phone_normalized =
        typeof iti.getNumber === "function" ? iti.getNumber() : customer_phone;
      let customer_company = $("#secure-checkout").find("#company").val();

      const productPriceValue = parseCurrencyAmount(primaryDesign.productPrice);
      const discountPercentValue = parsePercentAmount(primaryDesign.discountPercentage);
      const providedDiscountedUnitPriceValue = parseCurrencyAmount(primaryDesign.totalPrice);
      const quantityValue = parseQuantityValue(primaryDesign.quantity);

      const discountedUnitPriceValue =
        providedDiscountedUnitPriceValue !== null
          ? providedDiscountedUnitPriceValue
          : productPriceValue !== null
          ? discountPercentValue !== null
            ? roundToTwo(productPriceValue * (1 - discountPercentValue / 100))
            : roundToTwo(productPriceValue)
          : null;

      const lineTotalValue =
        discountedUnitPriceValue !== null && quantityValue !== null
          ? roundToTwo(discountedUnitPriceValue * quantityValue)
          : null;

      const designItemsObject = designItems.map((item) => {
        const itemProductPriceValue = parseCurrencyAmount(item.productPrice);
        const itemDiscountPercentValue = parsePercentAmount(item.discountPercentage);
        const itemProvidedDiscountedUnitPriceValue = parseCurrencyAmount(item.totalPrice);
        const itemQuantityValue = parseQuantityValue(item.quantity);
        const itemDiscountedUnitPriceValue =
          itemProvidedDiscountedUnitPriceValue !== null
            ? itemProvidedDiscountedUnitPriceValue
            : itemProductPriceValue !== null
            ? itemDiscountPercentValue !== null
              ? roundToTwo(itemProductPriceValue * (1 - itemDiscountPercentValue / 100))
              : roundToTwo(itemProductPriceValue)
            : null;
        const itemLineTotalValue =
          itemDiscountedUnitPriceValue !== null && itemQuantityValue !== null
            ? roundToTwo(itemDiscountedUnitPriceValue * itemQuantityValue)
            : null;

        return {
          ...item,
          quantityValue: itemQuantityValue,
          productPriceValue: itemProductPriceValue,
          discountPercentValue: itemDiscountPercentValue,
          discountedUnitPriceValue: itemDiscountedUnitPriceValue,
          lineTotalValue: itemLineTotalValue,
          sizeType: item.customWidth ? "custom" : "standard",
        };
      });
	
      let customerData = {}; // Initialize the customerData object
      let queryparameters; // Declare queryparameters outside the if block to make it accessible globally

      let currentUrl = window.location.href;
      
      // Check if the URL contains a query string
      if (currentUrl.includes("?")) {
        // Extract query string after '?'
        queryparameters = currentUrl.split("?")[1];
        console.log("queryparameters:", queryparameters);
        sessionStorage.setItem("queryparameters", queryparameters);

        // Parse query parameters into individual key-value pairs and add them to customerData
        queryparameters.split("&").forEach((param) => {
          const [key, value] = param.split("=");
          // Directly add each key-value pair to customerData
          customerData[key] = decodeURIComponent(value || ""); // Handle URL encoding
        });

        
      }

      // Now customerData contains all query parameters dynamically
      // console.log("Final customerData:", customerData);
     
      customerData["Firstname"] = customer_firstname;
      customerData["Surname"] = customer_surname;
      customerData["Email"] = customer_email;
      customerData["Phone"] = customer_phone;
      customerData["Phone Normalized"] = customer_phone_normalized;
      customerData["Company Name"] = customer_company;

      customerData["Location"] = primaryDesign.location;
      customerData["Orientation"] = primaryDesign.orientation;

      if (primaryDesign.customWidth) {
        customerData["Custom Width"] = primaryDesign.customWidth;
        customerData["Custom Length"] = primaryDesign.customLength;
      } else {
        customerData["Size"] = primaryDesign.size;
      }
      customerData["Product Price"] = primaryDesign.productPrice;
      customerData["Quantity"] = primaryDesign.quantity;
      customerData["Discount percentage"] = primaryDesign.discountPercentage;
      customerData["Total Price"] = primaryDesign.totalPrice;
      customerData["Size Type"] = primaryDesign.customWidth ? "custom" : "standard";

      if (productPriceValue !== null) {
        customerData["Unit Price Value"] = productPriceValue;
      }
      if (discountPercentValue !== null) {
        customerData["Discount Percent Value"] = discountPercentValue;
      }
      if (discountedUnitPriceValue !== null) {
        customerData["Discounted Unit Price Value"] = discountedUnitPriceValue;
      }
      if (quantityValue !== null) {
        customerData["Quantity Value"] = quantityValue;
      }
      if (lineTotalValue !== null) {
        customerData["Line Total Value"] = lineTotalValue;
      }
      customerData["Currency"] = "GBP";

      if (primaryDesign.color) {
        customerData["Color"] = primaryDesign.color;
      }

      if (primaryDesign.productVariantId) {
        customerData["Product Variant Id"] = primaryDesign.productVariantId;
      }

      if (primaryDesign.imageUrl) {
        customerData["Image URL"] = primaryDesign.imageUrl;
      }

      if (primaryDesign.backgroundColor) {
        customerData["Background Color"] = primaryDesign.backgroundColor;
      }

      customerData["Bespoke color"] = primaryDesign.bespokeColor;

      /* Logo Source — recorded by the Brandfetch logo finder
       * (`snippets/lm-logo-finder.liquid`) on the hidden input
       * `.main-product__uploaded-logo-source`. Values:
       *   "brandfetch" — customer used the auto-finder
       *   "upload"     — customer uploaded their own file
       *   ""           — customer skipped the upload step
       * Forwarded to postdata.php → Function App → Dataverse for
       * usage analytics on the Brandfetch integration. */
      var $logoSource = document.querySelector(".main-product__uploaded-logo-source");
      customerData["Logo Source"] = $logoSource ? ($logoSource.value || "") : "";

      customerData["Proof Mode"] = proofMode;
      customerData["Instant Proof Eligible"] = instantProofEligible ? "true" : "false";
      customerData["Requires Manual Review"] = requiresManualReview ? "true" : "false";
      customerData["Instant Proof Status"] = instantProofEligible ? "pending" : "skipped";
      customerData["Design Item Count"] = designItems.length;
      customerData["Design Items"] = JSON.stringify(designItems);
      customerData["Design Items Object"] = designItemsObject;

      const hasLogoUrl = safeTrim(primaryDesign.imageUrl || customerData["Image URL"]) !== "";
      const hasBackgroundColor =
        safeTrim(primaryDesign.backgroundColor || customerData["Background Color"] || primaryDesign.color) !== "";
      const shouldAttemptInstantProof = instantProofEligible && hasLogoUrl && hasBackgroundColor;

      customerData["Instant Proof Attempted"] = shouldAttemptInstantProof ? "true" : "false";
      if (!shouldAttemptInstantProof) {
        if (!instantProofEligible) {
          customerData["Instant Proof Skip Reason"] = "multi_item_or_manual_mode";
        } else if (!hasLogoUrl) {
          customerData["Instant Proof Skip Reason"] = "missing_logo_url";
        } else if (!hasBackgroundColor) {
          customerData["Instant Proof Skip Reason"] = "missing_background_color";
        }
      }

      /* Meta CAPI lead fields — fbc / fbp / user_agent / event_source_url /
       * marketing_consent. Forwarded by postdata.php AND the ProofCreate
       * Function App to Dataverse columns cr174_fbc / cr174_fbp /
       * cr174_useragent / cr174_eventsourceurl / cr174_marketingconsent (0|1).
       * client_ip is captured server-side from request headers. */
      try {
        if (typeof window.fmGetMetaLeadFields === 'function') {
          var __metaFields = window.fmGetMetaLeadFields();
          customerData["fbc"] = __metaFields.fbc || '';
          customerData["fbp"] = __metaFields.fbp || '';
          customerData["user_agent"] = __metaFields.user_agent || '';
          customerData["event_source_url"] = __metaFields.event_source_url || '';
          customerData["marketing_consent"] = !!__metaFields.marketing_consent;
        }
      } catch (e) { /* helper missing — lead still submits without CAPI fields */ }

      isCheckoutSubmitting = true;
      logoWizardState.isSubmissionComplete = false;
      setInstantProofDebugMessage("");
      setCheckoutSubmitState(
        true,
        "Please Wait, Generating Design"
      );

      const submitLeadPayload = function (instantOutcome) {
        const resolvedOutcome =
          instantOutcome ||
          normalizeInstantProofOutcome(
            {
              status: shouldAttemptInstantProof ? "manual_fallback" : "skipped",
              instantProofStatus: shouldAttemptInstantProof ? "failed" : "skipped",
              proofMode: proofMode,
              requiresManualReview: requiresManualReview,
            },
            shouldAttemptInstantProof ? "failed" : "skipped"
          );

        customerData["Proof Mode"] = resolvedOutcome.proofMode || proofMode;
        customerData["Instant Proof Status"] =
          resolvedOutcome.instantProofStatus || (shouldAttemptInstantProof ? "failed" : "skipped");
        customerData["Requires Manual Review"] =
          typeof resolvedOutcome.requiresManualReview === "boolean"
            ? (resolvedOutcome.requiresManualReview ? "true" : "false")
            : (requiresManualReview ? "true" : "false");

        if (resolvedOutcome.proofId) {
          customerData["Proof ID"] = resolvedOutcome.proofId;
        }
        if (resolvedOutcome.proofUrl) {
          customerData["Proof URL"] = resolvedOutcome.proofUrl;
        }
        if (resolvedOutcome.proofImageUrl) {
          customerData["Proof Image URL"] = resolvedOutcome.proofImageUrl;
        }
        if (resolvedOutcome.draftOrderId) {
          customerData["Draft Order ID"] = resolvedOutcome.draftOrderId;
        }
        if (resolvedOutcome.draftOrderInvoiceUrl) {
          customerData["Draft Order Invoice URL"] = resolvedOutcome.draftOrderInvoiceUrl;
        }
        if (
          resolvedOutcome.renderDurationMs !== null &&
          resolvedOutcome.renderDurationMs !== undefined &&
          !Number.isNaN(resolvedOutcome.renderDurationMs)
        ) {
          customerData["Instant Render Duration Ms"] = resolvedOutcome.renderDurationMs;
        }
        if (resolvedOutcome.errorCode) {
          customerData["Instant Error Code"] = resolvedOutcome.errorCode;
        }
        if (resolvedOutcome.errorMessage) {
          customerData["Instant Error Message"] = resolvedOutcome.errorMessage;
        }

        setInstantProofDebugMessage("");

        $.ajax({
          url: "https://firstmatsproofs.co.uk/firstmatsproofs.co.uk/eq-pdp-image/postdata.php",
          method: "POST",
          dataType: "JSON",
          contentType: "application/json; charset=utf-8",
          data: JSON.stringify(customerData),
          success: function () {
            /* 18-May-2026 — fire form-complete tracking in BOTH
             * success paths.
             *
             * Previously the instant-proof branch redirected to the
             * proof URL without ever adding `.form-submit-success`
             * to the form. The MutationObserver in
             * `snippets/lm-form-tracking.liquid` listens for that
             * class flip to fire the `lm_form_complete` GA4 event,
             * so the entire instant-proof success population (the
             * majority of completions in practice) was invisible
             * to GA4's funnel analytics.
             *
             * Fix: add the success class FIRST (before the path
             * branch). The class flip is what we treat as "the
             * customer's submission was accepted" — true whether
             * we then redirect to a proof page or keep them on the
             * wizard for the manual-review path. A brief (200ms)
             * delay before navigation gives the dataLayer push +
             * GTM trigger + GA4 sendBeacon a chance to flush before
             * the browser tears down the page. */
            $(".secure-checkout__form").addClass("form-submit-success");
            logoWizardState.isSubmissionComplete = true;

            /* ── Proof-stage funnel events (11-Jun-2026) ───────────────
             * Extends the GA4/PostHog logo-mat funnel PAST submission.
             * `lm_form_complete` (fired by snippets/lm-form-tracking.liquid
             * when `.form-submit-success` is added above) only tells us a
             * lead was accepted — not whether the customer reached the
             * instant-proof page on design.firstmats.co.uk. These three
             * mutually-exclusive events split the post-submit population:
             *
             *   lm_proof_shown    — instant proof rendered; we're about to
             *                       redirect to the proof page. Identity is
             *                       stitched across to design.firstmats.co.uk
             *                       via PostHog cross_subdomain_cookie, so the
             *                       proof-page pageview continues the SAME
             *                       person (see snippets/posthog-init.liquid).
             *   lm_proof_skipped  — eligible lead but no instant proof
             *                       possible (multi-item / no usable logo /
             *                       no background colour). Carries the reason.
             *   lm_proof_failed   — instant proof was attempted but the
             *                       render failed or timed out (manual fallback).
             *
             * Deferred via setTimeout(0) so this lands AFTER `lm_form_complete`
             * (which fires from a MutationObserver microtask on the class flip
             * above) — keeps the funnel event order correct. Still well inside
             * the 200ms pre-redirect window below. The auto-bridge in
             * posthog-init.liquid mirrors each dataLayer push into PostHog. */
            (function () {
              var DL = (window.dataLayer = window.dataLayer || []);
              var proofStatus = safeTrim(resolvedOutcome.instantProofStatus).toLowerCase();
              var handle =
                (primaryDesign && primaryDesign.productHandle) ||
                customerData["Product Handle"] ||
                "";
              setTimeout(function () {
                if (proofStatus === "success" && safeTrim(resolvedOutcome.proofUrl) !== "") {
                  DL.push({
                    event: "lm_proof_shown",
                    lm_proof_id: resolvedOutcome.proofId || "",
                    lm_proof_mode: resolvedOutcome.proofMode || "",
                    lm_render_duration_ms: resolvedOutcome.renderDurationMs,
                    lm_product_handle: handle,
                  });
                } else if (proofStatus === "skipped") {
                  /* Skip reason can be decided client-side (multi-item /
                   * no logo / no colour — written to customerData earlier)
                   * OR server-side (the ProofCreate API judged the logo
                   * unusable / product not instant-proofable and returned
                   * status "skipped" with no client reason). Prefer the
                   * client reason; else fall back to the server's errorCode
                   * (ignoring the bare "skipped" status echo it defaults to),
                   * so server-decided skips don't all bucket as "unknown".
                   * The freeform server message rides along as a debug
                   * detail (not for low-cardinality breakdowns). */
                  var serverCode = resolvedOutcome.errorCode;
                  if (safeTrim(serverCode).toLowerCase() === proofStatus) serverCode = "";
                  DL.push({
                    event: "lm_proof_skipped",
                    lm_skip_reason:
                      customerData["Instant Proof Skip Reason"] ||
                      serverCode ||
                      "unknown",
                    lm_skip_detail: resolvedOutcome.errorMessage || "",
                    lm_product_handle: handle,
                  });
                } else {
                  DL.push({
                    event: "lm_proof_failed",
                    lm_proof_status: proofStatus || "failed",
                    lm_error_code: resolvedOutcome.errorCode || "",
                    lm_product_handle: handle,
                  });
                }
              }, 0);
            })();

            if (
              resolvedOutcome.instantProofStatus === "success" &&
              safeTrim(resolvedOutcome.proofUrl) !== ""
            ) {
              setTimeout(function () {
                window.location.href = resolvedOutcome.proofUrl;
              }, 200);
              return;
            }

            showWizardStep(logoWizardState.currentStepIndex, { skipValidation: true });
            /* Force-manual mode: no instant proof, so the customer stays on the
               wizard showing the "request received" success body. Flip the green
               band to a completion state (must run AFTER showWizardStep, which
               would otherwise re-render the band to the contact step). */
            if (isForceManualMode()) {
              renderManualCompletionBand();
            }
            isCheckoutSubmitting = false;
            setCheckoutSubmitState(false);
          },
          error: function () {
            if ($(".secure-checkout__form").hasClass("form-submit-success")) {
              $(".secure-checkout__form").removeClass("form-submit-success");
            }
            logoWizardState.isSubmissionComplete = false;
            isCheckoutSubmitting = false;
            setCheckoutSubmitState(false);
          },
        });
      };

      /* NOTE: an earlier version of this code skipped the ProofCreate call
         for outdoor/circular templates on the assumption that the
         `submitLeadPayload` postdata.php endpoint would still log the lead
         in Dataverse. That was wrong — Dataverse writes happen INSIDE
         ProofCreate (see comment below). Skipping the call meant those
         leads landed in postdata.php only and never reached Dataverse,
         so M&A never saw them. The skip has been removed; ProofCreate is
         now called for every submission again. The "Missing background
         colour in payload." log noise on outdoor/circular submissions is
         being addressed on the Function App side (downgrade to info-level
         when `product_handle` contains outdoor/circular). */

      // Always call ProofCreate so every submission is logged in Dataverse,
      // even incomplete ones (missing logo / colour / multi-item). The
      // Function classifies these on its side and returns an appropriate outcome.
      const instantPayload = buildInstantProofRequestPayload(
        customerData,
        primaryDesign,
        designItems,
        designItemsObject
      );
      $.ajax({
        url: INSTANT_PROOF_API_URL,
        method: "POST",
        dataType: "JSON",
        contentType: "application/json; charset=utf-8",
        timeout: INSTANT_PROOF_CLIENT_TIMEOUT_MS,
        data: JSON.stringify(instantPayload),
        success: function (response) {
          const instantOutcome = normalizeInstantProofOutcome(response, "failed");
          submitLeadPayload(instantOutcome);
        },
        error: function (_xhr, textStatus) {
          const fallbackStatus = textStatus === "timeout" ? "timeout" : "failed";
          submitLeadPayload(
            normalizeInstantProofOutcome(
              {
                status: "manual_fallback",
                instantProofStatus: fallbackStatus,
                proofMode: "manual",
                requiresManualReview: true,
                message:
                  fallbackStatus === "timeout"
                    ? "Instant proof timed out."
                    : "Instant proof request failed.",
              },
              fallbackStatus
            )
          );
        },
      });
    }
  });

  /* get JS Work start */

  $(".custom-mats-product__tabs .tab-a").on("click", function () {
    /* Sync the panel visibility (CSS-driven .tab-active class) */
    $(".custom-mats-product__tabs .tab").removeClass("tab-active");
    $(
      ".custom-mats-product__tabs .tab[data-id='" +
        $(this).attr("data-id") +
        "']"
    ).addClass("tab-active");
    /* Sync the tab button styling + ARIA state. `aria-selected`
       added 26-May-2026 alongside the `<a>`-to-`<button>` swap so
       screen readers track which tab is current. */
    $(".custom-mats-product__tabs .tab-a")
      .removeClass("active")
      .attr("aria-selected", "false");
    $(this)
      .addClass("active")
      .attr("aria-selected", "true");
  });

  $(".custom-mats-product__video-play").click(function () {
    // Hide the banner
    $(this).parent().hide();

    const videoSrc = $("#youtubeVideo").attr("src") + "&autoplay=1";
    $("#youtubeVideo").attr("src", videoSrc);

    // Show the video container
    $("#videoContainer").css("display", "block");

    // Get the original src, add autoplay, and set it back
  });

  if (
    $(".js-product-lovedby-slider").length > 0 &&
    !$(".js-product-lovedby-slider").hasClass("slick-initialized")
  ) {
    $(".js-product-lovedby-slider").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      fade: false,
      autoplay: true,
      autoplaySpeed: 2000,
      prevArrow:
        '<button type="button" class="prev-arrow" aria-label="Previous slide"><svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23 15L17 21L23 27" stroke="#7D86BC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="20.5" cy="20.5" r="20" transform="rotate(-180 20.5 20.5)" stroke="#7D86BC"/></svg></button>',
      nextArrow:
        '<button type="button" class="next-arrow" aria-label="Next slide"><svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 26L24 20L18 14" stroke="#7D86BC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="20.5" cy="20.5" r="20" stroke="#7D86BC"/></svg></button>',
      responsive: [
        {
          breakpoint: 991.98,
          settings: {
            slidesToShow: 2,
            arrows: true,
          },
        },
        {
          breakpoint: 575.98,
          settings: {
            slidesToShow: 1,
            arrows: true,
            prevArrow:
              '<button type="button" class="prev-arrow" aria-label="Previous slide"><svg width="41" height="42" viewBox="0 0 41 42" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20.5" cy="21" r="20" transform="rotate(-180 20.5 21)" fill="#7D86BC" stroke="#7D86BC"/><path d="M23 15.5L17 21.5L23 27.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
            nextArrow:
              '<button type="button" class="next-arrow" aria-label="Next slide"><svg width="41" height="42" viewBox="0 0 41 42" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20.5" cy="21" r="20" fill="#7D86BC" stroke="#7D86BC"/><path d="M18 26.5L24 20.5L18 14.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
          },
        },
      ],
    });
  }

  /* get JS Work start */
});

/*
Phone Number Validation (intl-tel-input)
if (iti) {
    let phoneNumber = iti.getNumber(); // Get formatted phone number

    if (phoneNumber && phoneNumber !== "+" && phoneNumber.length > 1) { // Check if there's a value and it's not just the "+" sign
        let phoneValid = iti.isValidNumber(); // Check if the phone number is valid
        if (phoneValid) {
            // Valid field: Remove error message and invalid class
            phoneNumberField.removeClass("invalid");
            $("#phoneError").hide();
        } else {
            // Invalid field: Show error message and add invalid class
            isValid = false;
            phoneNumberField.addClass("invalid");
            $("#phoneError").text("Please enter a valid phone number.").css('display','block');
        }
    } else {
        // Empty field: Show error message and add invalid class
        isValid = false;
        phoneNumberField.addClass("invalid");
        $("#phoneError").text("Phone number is required.").css('display','block');
    }

} else {
    // If iti is not initialized, show error
    isValid = false;
    phoneNumberField.addClass("invalid");
    $("#phoneError").text("Phone number is required.").css('display','block');
}

*/

/* 
Initialize the intlTelInput instance
iti = window.intlTelInput($(phoneNumberField), {
    initialCountry: "auto",  // Auto-detect the country based on the user's IP
    separateDialCode: true, // Display the dial code together with the flag
    formatOnDisplay: true,   // Format the number when displayed
    nationalMode: false,     // Force international number formatting
    geoIpLookup: function (callback) {
        $.get('https://ipinfo.io', function () {}, "jsonp").always(function (resp) {
            var countryCode = (resp && resp.country) ? resp.country : "";
            callback(countryCode);
        });
    },
    utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/12.0.3/js/utils.js", // Optional utils script for number formatting and validation
    preferredCountries: [] // Optional: you can list preferred countries here (e.g., ['us', 'gb'])

});
*/

// custom option price handler
function customPriceHandler(selectedOption) { 
  
  const widthInput = document.querySelector('input[name="width"]');
  const lengthInput = document.querySelector('input[name="length"]');
  if (!widthInput || !lengthInput) {
    return;
  }
  const bundlePriceDisplays = document.querySelectorAll(
    ".cw-product-bundle__variant-price"
  );
  const bundleOptionPriceDisplays = document.querySelectorAll(
    ".cw-product-bundle__variant-option"
  );

  function calculatePrice() {
    const width = parseFloat(widthInput.value) || 0;
    const length = parseFloat(lengthInput.value) || 0;

    if (width > 0 && length > 0) {
      const area = width * length;
      // VAT-toggle aware (08-Jun-2026): always compute the EX base price,
      // derive INC (×1.2), and display whichever matches the current mode.
      // Both formatted values are stashed on the price elements so a
      // later toggle re-swaps without recomputing.
      const price = ((area / 10000) * 50.46 + 13) * 1.6;       // ex, in £
      const priceInc = price * 1.2;                            // inc, in £
      const fmIncMode = (window.fmVatMode === "inc");
      const formattedPriceEx  = Shopify.formatMoney(price * 100);
      const formattedPriceInc = Shopify.formatMoney(priceInc * 100);
      const formattedPrice    = fmIncMode ? formattedPriceInc : formattedPriceEx;

      $(".main-product__price-value")
        .attr("data-ex-price", formattedPriceEx)
        .attr("data-inc-price", formattedPriceInc)
        .text(formattedPrice);
      $(".main-product__size-option").find(".cw-product-bundle__variant-selected .cw-product-bundle__variant-price").attr('data-without-money-total', formattedPrice)
      bundlePriceDisplays.forEach((element) => {
        element.textContent = formattedPrice;
      });
      bundleOptionPriceDisplays.forEach((ele) => {
        if (ele.getAttribute("data-text").includes("Custom Size")) {
          // data-price stays EX (display base); add data-price-inc for the
          // dropdown JS, and data-variant-price stays EX pence (calc base).
          ele.setAttribute("data-price", formattedPriceEx);
          ele.setAttribute("data-price-inc", formattedPriceInc);
          ele.setAttribute("data-variant-price", price * 100);
          var customOptPriceEl = ele.querySelector(".cw-product-bundle__option-price");
          if (customOptPriceEl) {
            customOptPriceEl.setAttribute("data-ex-price", formattedPriceEx);
            customOptPriceEl.setAttribute("data-inc-price", formattedPriceInc);
            customOptPriceEl.textContent = formattedPrice;
          }
        }
      });

      quantityPriceHandler(price * 100); // Pass raw price as a number
      $(".cw-product-bundle__variant-price").show();
      updateCustomSizeLabels();
    } else {
      $(".cw-product-bundle__variant-price").hide();
      updateCustomSizeLabels();
    }
    $('.cw-product-bundle__variant-option[data-selected-qty="1"]')
      .show()
      .addClass("active-status");
    $(
      '.cw-product-bundle__variant-option[data-selected-qty]:not([data-selected-qty="1"])'
    )
      .hide()
      .removeClass("active-status");
  }

  if (!widthInput.dataset.logoMatCustomSizeBound) {
    widthInput.addEventListener("input", calculatePrice);
    lengthInput.addEventListener("input", calculatePrice);
    widthInput.dataset.logoMatCustomSizeBound = "true";
  }

  calculatePrice();
}

function quantityPriceHandler(money) {
  
  // console.log("Base money:", money);
  const percentageOffElement = document.querySelector(
    ".main-product__quantity-option .cw-product-bundle__variant-save-percentage"
  );
  const percentageOff = percentageOffElement
    ? percentageOffElement.textContent.replace(/Save\s*/i, "").trim()
    : "";

  const PercentageFifteen = $(
    '.cw-product-bundle__variant-option[data-selected-qty="2"]'
  ).attr("data-save-percentage");
  const PercentageFifteenCleaned = PercentageFifteen.replace(
    /Save\s*/i,
    ""
  ).trim();
  const PercentageFifteenFormate = parseFloat(PercentageFifteenCleaned) / 100;

  const PercentageTwenty = $(
    '.cw-product-bundle__variant-option[data-selected-qty="3"]'
  ).attr("data-save-percentage");
  const PercentageTwentyCleaned = PercentageTwenty.replace(
    /Save\s*/i,
    ""
  ).trim();
  const PercentageTwentyFormate = parseFloat(PercentageTwentyCleaned) / 100;

  const PercentageThirty = $(
    '.cw-product-bundle__variant-option[data-selected-qty="4"]'
  ).attr("data-save-percentage");
  const PercentageThirtyCleaned = PercentageThirty.replace(
    /Save\s*/i,
    ""
  ).trim();
  const PercentageThirtyFormate = parseFloat(PercentageThirtyCleaned) / 100;
  // Calculate 15% and 20% discounts
  const fifteenPercentOff = money - money * PercentageFifteenFormate;
  const twentyPercentOff = money - money * PercentageTwentyFormate;
  const thirtyPercentOff = money - money * PercentageThirtyFormate;

  let price;
  if (percentageOff === PercentageThirty) {
    price = Shopify.formatMoney(thirtyPercentOff);
  } else if (percentageOff === PercentageTwenty) {
    price = Shopify.formatMoney(twentyPercentOff);
  } else if (percentageOff === PercentageFifteen) {
    price = Shopify.formatMoney(fifteenPercentOff);
  } else {
    price = Shopify.formatMoney(money);
  }

  // Update main quantity option price display
  const mainPriceElement = document.querySelector(
    ".main-product__quantity-option .cw-product-bundle__variant-price"
  );
  if (mainPriceElement) {
    mainPriceElement.innerHTML = price;
    // console.log("price changed along with qty!!");
  }

  // Function to update variant options
  const updateVariantOption = (qty, discountPrice) => {
    const variantOption = document.querySelector(
      `.cw-product-bundle__variant-option[data-selected-qty="${qty}"]`
    );
    if (variantOption) {
      variantOption.setAttribute("data-price", discountPrice);
      const optionPriceElement = variantOption.querySelector(
        ".cw-product-bundle__option-price"
      );
      if (optionPriceElement) {
        optionPriceElement.innerHTML = discountPrice;
      }
    }
  };

  // Update each variant option price
  updateVariantOption("4", Shopify.formatMoney(thirtyPercentOff));
  updateVariantOption("3", Shopify.formatMoney(twentyPercentOff));
  updateVariantOption("2", Shopify.formatMoney(fifteenPercentOff));
  updateVariantOption("1", Shopify.formatMoney(money));

  // console.log("20% Discounted Price:", Shopify.formatMoney(twentyPercentOff));
  // console.log("15% Discounted Price:", Shopify.formatMoney(fifteenPercentOff));
  // console.log("Original Price:", Shopify.formatMoney(money));
}

// Listen for events like afterClose, close, clickOutside after Fancybox has been opened
// Fancybox.defaults.afterClose = function() {
//   console.log("afterClose");
//   // Remove class from form after closing
//   const form = document.querySelector('.secure-checkout__form');
//   if (form && form.classList.contains('form-submit-success')) {
//     form.classList.remove('form-submit-success');
//   }
// };

// Fancybox.defaults.on = {
//   close: function() {
//     console.log("close");
//     const form = document.querySelector('.secure-checkout__form');
//     if (form && form.classList.contains('form-submit-success')) {
//       form.classList.remove('form-submit-success');
//     }
//   },
//   clickOutside: function() {
//     console.log("clickOutside");
//     const form = document.querySelector('.secure-checkout__form');
//     if (form && form.classList.contains('form-submit-success')) {
//       form.classList.remove('form-submit-success');
//     }
//   }
// };

$("#fourplusqty").on("input", function () {
  // Get the value of the changed input
  let qtyText =
    $(".main-product__quantity-option .cw-product-bundle__variant-option").attr(
      "data-text"
    ) || "";
  var inputValue = $(this).val();
  if (qtyText == "4+ Qty") {
  }
  $(".main-product__quantity-option .cw-product-bundle__variant-selected").attr(
    "currentqty",
    inputValue
  );
});

// $(document).on("click", ".js-click-step-sigh-up", function(){
//   $(this).parent('.first-screen').hide();
//   $(this).parent('.first-screen').siblings('.second-screen').show();
// })

